{
  "PDF preview": "Aperçu PDF",
  "Zoom out": "Réduire",
  "Zoom in": "Agrandir",
  "Fit width": "Ajuster à la largeur",
  "Choose valid collection columns without duplicates.": "Choisissez des colonnes de liste valides sans doublons.",
  "Settings": "Paramètres",
  "Main menu": "Menu principal",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", pas",
  ". Changing construction class requires a different identity.": ". Un autre type de construction exige une autre identité.",
  ". It is shown only once.": ". Affiché une seule fois.",
  ". Where-used follows the actual structure—not the numbering path.": ". Les utilisations suivent la structure réelle, pas le chemin de numérotation.",
  "? The history remains.": "? L’historique est conservé.",
  "? The original part remains in the registry.": "? La pièce d’origine reste dans le registre.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "Un PIN nécessite un projet, une version produit et au moins un nœud d’identité ; profondeur maximale : 32.",
  "A change is awaiting confirmation": "Modification en attente de confirmation",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "Un changement de type contrôlé exige une nouvelle pièce, pas un renommage.",
  "A new link will replace the previous invitation link for": "Le nouveau lien remplacera l’invitation précédente pour",
  "A part cannot replace itself.": "Une pièce ne peut pas se remplacer elle-même.",
  "A piece part cannot have a configuration.": "Une pièce élémentaire ne peut pas avoir de configuration.",
  "A piece part cannot have controlled children.": "Une pièce élémentaire ne peut pas contenir de composants contrôlés.",
  "A piece part cannot retain controlled children.": "Une pièce élémentaire ne peut pas conserver de composants contrôlés.",
  "A qualified reference must select a released revision.": "Une référence qualifiée doit sélectionner une révision publiée.",
  "A verified Google email is required.": "Une adresse e-mail Google vérifiée est requise.",
  "ALPHA": "ALPHA",
  "About {value0}": "À propos de {value0}",
  "Accept company invitation": "Accepter l’invitation de l’entreprise",
  "Account": "Compte",
  "Account and company settings": "Paramètres du compte et de l’entreprise",
  "Active": "Active",
  "Active assembly": "Assemblage actuel",
  "Add alias": "Ajouter un numéro externe",
  "Add code": "Ajouter un code",
  "Add directional replacement": "Ajouter un remplacement directionnel",
  "Add part": "Ajouter une pièce",
  "Add replacement": "Ajouter un remplacement",
  "Add to {value0}": "Ajouter à {value0}",
  "Adding…": "Ajout…",
  "Alias notes": "Notes du numéro externe",
  "Alias organization": "Organisation du numéro externe",
  "Alias type": "Type de numéro externe",
  "All alias types": "Tous les types de numéros externes",
  "All companies": "Toutes les entreprises",
  "All selected child revisions must be released.": "Toutes les révisions de composants sélectionnées doivent être publiées.",
  "All states": "Tous les états",
  "All types": "Tous les types",
  "Aluminium": "Aluminium",
  "An assembly needs at least one controlled child before release.": "Un assemblage nécessite au moins un composant contrôlé avant publication.",
  "An example drawing change tightens a tolerance.": "La modification de dessin en exemple resserre une tolérance.",
  "An external alias cannot impersonate another canonical part number.": "Un numéro externe ne peut pas usurper le numéro canonique d’une autre pièce.",
  "An identifier or historical alias already occupies the requested number.": "Ce numéro est déjà occupé par une identité ou un alias historique.",
  "An independently orderable configured product needs its own assembly P/N.": "Un produit configuré commandable séparément nécessite son propre numéro d’assemblage.",
  "An invitation is already pending. Replace its link instead.": "Une invitation est déjà en attente. Remplacez son lien.",
  "An occurrence cannot be moved to another owner by editing it.": "Une utilisation ne peut pas changer de structure propriétaire par modification.",
  "Another change was being saved. Retry this same request.": "Une autre modification était en cours. Réessayez la même requête.",
  "Another owner must accept membership before removing the last owner.": "Un autre propriétaire doit accepter l’invitation avant le retrait du dernier propriétaire.",
  "Another project": "Autre projet",
  "Apply filters": "Appliquer les filtres",
  "Arm": "Bras",
  "Arm assembly": "Assemblage du bras",
  "As authored": "Unités d’origine",
  "Ask a company owner to register a new code.": "Demandez au propriétaire de l’entreprise d’enregistrer un nouveau code.",
  "Assembly": "Assemblage",
  "Assembly configurations": "Configurations d’assemblage",
  "Assignment correction": "Correction d’attribution",
  "Back to blueprint": "Retour au plan",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "Avant toute dépendance contrôlée, corrigez l’attribution avec une trace d’audit. L’ancien numéro n’est pas redirigé.",
  "Best match": "Meilleure correspondance",
  "Bonded": "Collé",
  "Bonded assembly": "Assemblage collé",
  "Bonded grip": "Poignée collée",
  "Both leaders point to the same P/N.": "Les deux repères pointent vers le même numéro de pièce.",
  "CF": "CF",
  "Cancel": "Annuler",
  "Cancel {value0} edit": "Annuler la modification de {value0}",
  "Carbon fibre": "Fibre de carbone",
  "Change {value0}'s role": "Changer le rôle de {value0}",
  "Check result": "Vérifier le résultat",
  "Choose Active, Obsolete or Retired.": "Choisissez Actif, Obsolète ou Retiré.",
  "Choose Owner, Editor or Viewer.": "Choisissez Propriétaire, Éditeur ou Lecteur.",
  "Choose P, A, W, G or R.": "Choisissez P, A, W, G ou R.",
  "Choose a company": "Choisir une entreprise",
  "Choose a measurement unit preference.": "Choisissez un système d’unités.",
  "Choose a part and exact revision from this company.": "Choisissez une pièce et sa révision exacte dans cette entreprise.",
  "Choose a product version from the default project.": "Choisissez une version produit du projet par défaut.",
  "Choose a standard position or register its code in this company.": "Choisissez une position standard ou enregistrez son code dans cette entreprise.",
  "Choose a supplier, manufacturer or customer alias.": "Choisissez un numéro fournisseur, fabricant ou client.",
  "Choose a supported interface language.": "Choisissez une langue d’interface prise en charge.",
  "Choose a supported regional format.": "Choisissez un format régional pris en charge.",
  "Choose a table density.": "Choisissez une densité de tableau.",
  "Choose a valid alias type.": "Choisissez un type de numéro externe valide.",
  "Choose a valid part state.": "Choisissez un état de pièce valide.",
  "Choose a valid part type.": "Choisissez un type de pièce valide.",
  "Choose a valid results page and page size.": "Choisissez une page et une taille de page valides.",
  "Choose a valid search order.": "Choisissez un ordre de recherche valide.",
  "Choose a valid time zone.": "Choisissez un fuseau horaire valide.",
  "Choose an assembly parent in the selected product version.": "Choisissez un assemblage parent dans cette version produit.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Choisissez un parent de cette version produit hors des descendants de cette identité.",
  "Choose an editable assembly and an exact part revision.": "Choisissez un assemblage modifiable et une révision exacte de pièce.",
  "Choose each time": "Choisir à chaque fois",
  "Choose exactly one structure owner.": "Choisissez exactement un propriétaire de structure.",
  "Choose its revision and quantity to add it to this assembly.": "Choisissez la révision et la quantité à ajouter à cet assemblage.",
  "Choose one structure owner.": "Choisissez un propriétaire de structure.",
  "Choose the default company first.": "Choisissez d’abord l’entreprise par défaut.",
  "Choose the part that can replace this one.": "Choisissez la pièce pouvant remplacer celle-ci.",
  "Class": "Classe",
  "Clear filters": "Effacer les filtres",
  "Close": "Fermer",
  "Close reuse parts": "Fermer la réutilisation des pièces",
  "Close {value0}": "Fermer {value0}",
  "Code": "Code",
  "Comfortable": "Confortable",
  "Compact": "Compacte",
  "Companies": "Entreprises",
  "Company": "Entreprise",
  "Company code": "Code de l’entreprise",
  "Company name": "Nom de l’entreprise",
  "Company not found.": "Entreprise introuvable.",
  "Company parts": "Pièces de l’entreprise",
  "Company settings": "Paramètres de l’entreprise",
  "Company-wide role": "Rôle dans l’entreprise",
  "Configuration": "Configuration",
  "Configuration name": "Nom de configuration",
  "Configurations": "Configurations",
  "Configurations apply to assemblies, not piece parts.": "Les configurations concernent les assemblages, pas les pièces élémentaires.",
  "Construction classes": "Types de construction",
  "Copy a revision of this part.": "Copier une révision de cette pièce.",
  "Correct engineering identity": "Corriger l’identité technique",
  "Corrected text": "Texte corrigé",
  "Correction & replacement": "Correction et remplacement",
  "Correction reason": "Motif de correction",
  "Cover": "Capot",
  "Cover numbered beneath it": "Capot numéroté sous cet assemblage",
  "Cover revisions": "Révisions du capot",
  "Cover · 1 each · forearm": "Capot · 1 pièce · avant-bras",
  "Create company": "Créer une entreprise",
  "Create configuration": "Créer une configuration",
  "Create invitation": "Créer l’invitation",
  "Create project": "Créer un projet",
  "Create variant": "Créer une variante",
  "Create version": "Créer la version",
  "Current structure": "Structure actuelle",
  "Default quantity unit": "Unité de quantité par défaut",
  "Default workspace": "Espace de travail par défaut",
  "Description": "Description",
  "Details": "Détails",
  "Different identity": "Autre identité",
  "Directional replacements": "Remplacements directionnels",
  "Draft": "Brouillon",
  "Drawing unavailable. Part-number examples remain interactive.": "Dessin indisponible. Les exemples de numéros restent interactifs.",
  "ER": "ER",
  "Edit company": "Modifier l’entreprise",
  "Edit configuration": "Modifier la configuration",
  "Edit details": "Modifier les détails",
  "Edit part details": "Modifier les détails de la pièce",
  "Edit part use": "Modifier l’utilisation de la pièce",
  "Edit product version": "Modifier la version produit",
  "Edit project": "Modifier le projet",
  "Editor": "Éditeur",
  "Engineering": "Ingénierie",
  "Engineering Registry": "Registre d’ingénierie",
  "Enter a canonical PIN.": "Saisissez un PIN canonique.",
  "Enter a position code.": "Saisissez un code de position.",
  "Enter a positive quantity and a unit.": "Saisissez une quantité positive et une unité.",
  "Enter a valid email address.": "Saisissez une adresse valide.",
  "Enter a variant code.": "Saisissez un code de variante.",
  "Exact child revision": "Révision exacte du composant",
  "Exact children in this baseline": "Composants exacts de cette référence",
  "Existing codes…": "Codes existants…",
  "Existing hand, used in V": "Main existante, utilisée dans V",
  "Existing part": "Pièce existante",
  "Explain": "Expliquer",
  "External aliases": "Numéros externes",
  "External part number": "Numéro de pièce externe",
  "Filters": "Filtres",
  "Find an existing part": "Trouver une pièce existante",
  "Find parts": "Trouver des pièces",
  "Find {value0}": "Trouver {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "Pour une pièce indépendante, laissez la pièce apparentée vide afin d’attribuer un nouveau numéro.",
  "Forearm cover": "Capot d’avant-bras",
  "Front view · left/right is the robot’s own left/right": "Vue de face · gauche/droite du robot",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Vue de face : la main droite du robot est à gauche du dessin, sa main gauche à droite.",
  "Google account email": "E-mail du compte Google",
  "Google could not verify this sign-in. Try again.": "Google n’a pas pu vérifier cette connexion. Réessayez.",
  "Google sign-in could not load. Check your connection and try again.": "Connexion Google indisponible. Vérifiez votre connexion et réessayez.",
  "Google sign-in is not configured.": "La connexion Google n’est pas configurée.",
  "Hand identities": "Identités des mains",
  "Head casing": "Boîtier de tête",
  "Hide": "Masquer",
  "Historical rename": "Renommage historique",
  "History": "Historique",
  "Hole Ø6 mm · tolerance ±": "Trou Ø6 mm · tolérance ±",
  "Identity family": "Famille d’identités",
  "Identity history examples": "Exemples d’historique d’identité",
  "Illustrative example · not your registry": "Exemple illustratif · pas votre registre",
  "Imperial": "Impériales",
  "Interactive robot part numbers": "Numéros de pièces interactifs du robot",
  "Invitation link": "Lien d’invitation",
  "Invitation not found.": "Invitation introuvable.",
  "Invite person": "Inviter une personne",
  "Issue part number": "Attribuer un numéro de pièce",
  "Issue variant": "Attribuer une variante",
  "Issuing the cover beneath it appends": "Le numéro d’un capot créé sous cet assemblage ajoute",
  "It does not tell you where it is used now.": "Cela n’indique pas son utilisation actuelle.",
  "Keep the part number and name columns; each column may appear only once.": "Conservez numéro et nom ; chaque colonne ne peut apparaître qu’une fois.",
  "Knee pin ×2": "Axe de genou ×2",
  "Language": "Langue",
  "Left / right": "Gauche / droite",
  "Left hand": "Main gauche",
  "Left hand · 1 each · wrist": "Main gauche · 1 pièce · poignet",
  "Loading…": "Chargement…",
  "Main navigation": "Navigation principale",
  "Material": "Matériau",
  "Meaning": "Signification",
  "Measurement units": "Unités de mesure",
  "Members": "Membres",
  "Metric": "Métriques",
  "Move {column} down": "Descendre {column}",
  "Move {column} up": "Monter {column}",
  "Name": "Nom",
  "Navigation": "Navigation",
  "Neither family membership nor a variant code promises interchangeability.": "Ni la famille ni le code de variante ne garantissent l’interchangeabilité.",
  "New assembly": "Nouvel assemblage",
  "New camera in V2": "Nouvelle caméra dans V2",
  "New camera, first numbered in V2": "Nouvelle caméra, numérotée pour la première fois dans V2",
  "New codes are registered by a company owner.": "Les nouveaux codes sont enregistrés par un propriétaire de l’entreprise.",
  "New company": "Nouvelle entreprise",
  "New configuration": "Nouvelle configuration",
  "New part": "Nouvelle pièce",
  "New product version": "Nouvelle version produit",
  "New project": "Nouveau projet",
  "New revision": "Nouvelle révision",
  "New version": "Nouvelle version",
  "No choices available.": "Aucun choix disponible.",
  "No parts yet.": "Aucune pièce pour le moment.",
  "No selected occurrences.": "Aucune utilisation sélectionnée.",
  "None": "Aucune",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Pas encore confirmé. Réessayez la modification conservée pour vérifier le résultat sans risque.",
  "Not found.": "Introuvable.",
  "Notes": "Notes",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Numéroter sous un assemblage n’ajoute pas le capot à sa structure. L’ajout est séparé ; la réutilisation conserve ce numéro.",
  "Numbering concept": "Concept de numérotation",
  "Numbering path": "Chemin de numérotation",
  "Obsolete": "Obsolète",
  "Old text": "Ancien texte",
  "Only !REV changes.": "Seul !REV change.",
  "Only company owners can manage membership.": "Seuls les propriétaires de l’entreprise peuvent gérer les membres.",
  "Only the configured administrator can create companies.": "Seul l’administrateur configuré peut créer des entreprises.",
  "Open PIN": "Ouvrir le PIN",
  "Open navigation": "Ouvrir la navigation",
  "Open project explorer": "Ouvrir l’explorateur de projets",
  "Organization": "Organisation",
  "Original identity": "Identité d’origine",
  "Overview": "Aperçu",
  "Owner": "Propriétaire",
  "P/N prefix": "Préfixe du numéro",
  "P/N preview": "Aperçu du numéro",
  "Page not found": "Page introuvable",
  "Part": "Pièce",
  "Part name": "Nom de pièce",
  "Part number": "Numéro de pièce",
  "Part number preview": "Aperçu du numéro de pièce",
  "Part number ↑": "Numéro de pièce ↑",
  "Part number ↓": "Numéro de pièce ↓",
  "Part number, name, material or alias": "Numéro, nom, matériau ou numéro externe",
  "Part numbering guide": "Guide de numérotation des pièces",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Les préfixes changent ensemble ; les identifiants historiques contrôlés restent redirigés.",
  "Part record": "Fiche de pièce",
  "Part section": "Section de pièce",
  "Part type": "Type de pièce",
  "Parts": "Pièces",
  "Parts first numbered in this product version.": "Pièces numérotées pour la première fois dans cette version produit.",
  "Per page": "Par page",
  "Personal preferences": "Préférences personnelles",
  "Piece": "Pièce",
  "Piece part": "Pièce élémentaire",
  "Piece parts cannot have controlled children.": "Les pièces élémentaires ne peuvent pas contenir de composants contrôlés.",
  "Piece parts do not have assembly configurations.": "Les pièces élémentaires n’ont pas de configurations d’assemblage.",
  "Position": "Position",
  "Position code": "Code de position",
  "Position codes contain 1–12 uppercase letters.": "Les codes de position contiennent 1 à 12 lettres latines majuscules.",
  "Product shown": "Produit affiché",
  "Product version": "Version du produit",
  "Product versions": "Versions du produit",
  "Project": "Projet",
  "Project / product version": "Projet / version produit",
  "Project code": "Code du projet",
  "Project explorer": "Explorateur de projets",
  "Project name": "Nom du projet",
  "Project settings": "Paramètres du projet",
  "Project workspace": "Espace de travail du projet",
  "Projects": "Projets",
  "Quantity": "Quantité",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Quantité et position appartiennent à chaque utilisation, pas à l’identité de la pièce. Les deux genoux sélectionnent la révision 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "La quantité doit être positive, inférieure ou égale à un milliard, avec six décimales au maximum.",
  "ROBOT project": "Projet ROBOT",
  "Reason for changing the code": "Motif du changement de code",
  "Reason for correcting the code": "Motif de correction du code",
  "Reason for correcting version number": "Motif de correction du numéro de version",
  "Regional format": "Format régional",
  "Register code": "Enregistrer le code",
  "Register variant code": "Enregistrer le code de variante",
  "Registered meanings cannot be reassigned after use.": "Les significations enregistrées ne peuvent plus être réattribuées après utilisation.",
  "Registered {value0} codes": "Codes {value0} enregistrés",
  "Registry": "Registre",
  "Related identities are not automatically interchangeable.": "Les identités apparentées ne sont pas automatiquement interchangeables.",
  "Related part": "Pièce apparentée",
  "Release configuration": "Publier la configuration",
  "Release each selected child revision before releasing this assembly.": "Publiez chaque révision de composant sélectionnée avant cet assemblage.",
  "Release the assembly revision before releasing this configuration.": "Publiez la révision d’assemblage avant cette configuration.",
  "Released": "Publiée",
  "Released arm baseline": "Référence publiée du bras",
  "Released configurations cannot be changed. Create a new configuration.": "Les configurations publiées sont immuables. Créez-en une nouvelle.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Les définitions publiées restent inchangées. Créez une nouvelle révision pour les modifier.",
  "Released structures stay unchanged. Create a new revision.": "Les structures publiées restent inchangées. Créez une nouvelle révision.",
  "Reload saved preferences": "Recharger les préférences enregistrées",
  "Reload structure": "Recharger la structure",
  "Remove": "Retirer",
  "Remove access": "Retirer l’accès",
  "Remove alias": "Retirer le numéro externe",
  "Remove external alias?": "Retirer le numéro externe ?",
  "Remove from assembly": "Retirer de l’assemblage",
  "Remove from assembly?": "Retirer de l’assemblage ?",
  "Remove saved search": "Supprimer la recherche enregistrée",
  "Remove saved search?": "Supprimer la recherche enregistrée ?",
  "Remove {value0}'s access?": "Retirer l’accès de {value0} ?",
  "Replace invitation link?": "Remplacer le lien d’invitation ?",
  "Replace link": "Remplacer le lien",
  "Replacement": "Remplacement",
  "Replacement conditions": "Conditions de remplacement",
  "Results per page": "Résultats par page",
  "Retired": "Retiré",
  "Retry saved change": "Réessayer la modification conservée",
  "Reuse & structure": "Réutilisation et structure",
  "Reuse parts": "Réutiliser des pièces",
  "Reuse source": "Source de réutilisation",
  "Rev": "Rév.",
  "Revision": "Révision",
  "Revision and configuration numbers must be positive.": "Les numéros de révision et de configuration doivent être positifs.",
  "Revision structures are selected by revision, not by project snapshot.": "Les structures sont sélectionnées par révision, pas par instantané de projet.",
  "Revisions": "Révisions",
  "Revoke invitation": "Révoquer l’invitation",
  "Revoke invitation?": "Révoquer l’invitation ?",
  "Right hand": "Main droite",
  "Riveted": "Riveté",
  "Riveted assembly": "Assemblage riveté",
  "Riveted chest panel": "Panneau de poitrine riveté",
  "Robot numbering guide": "Guide de numérotation du robot",
  "Same assembly and revision, different frozen selections.": "Même assemblage et révision, sélections figées différentes.",
  "Same cover identity": "Même identité de capot",
  "Save": "Enregistrer",
  "Save as a new search": "Enregistrer comme nouvelle recherche",
  "Save changes": "Enregistrer les modifications",
  "Save configuration": "Enregistrer la configuration",
  "Save project": "Enregistrer le projet",
  "Save replacement": "Enregistrer le remplacement",
  "Save search": "Enregistrer la recherche",
  "Saved change recovery": "Récupération de modification",
  "Saved searches": "Recherches enregistrées",
  "Saving…": "Enregistrement…",
  "Search": "Rechercher",
  "Search columns and order": "Colonnes et ordre de recherche",
  "Search company parts": "Rechercher des pièces de l’entreprise",
  "Search filters": "Filtres de recherche",
  "Search name": "Nom de recherche",
  "Search order": "Ordre de recherche",
  "Search part numbers or names": "Rechercher des numéros ou noms de pièces",
  "Searching…": "Recherche…",
  "Search…": "Rechercher…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Sélectionnez un capot pour voir son numéro sur le robot. Une géométrie similaire peut avoir un matériau et une définition différents.",
  "Select a revision of this assembly.": "Sélectionnez une révision de cet assemblage.",
  "Select a variant code registered in this company.": "Sélectionnez un code de variante enregistré dans cette entreprise.",
  "Select an assembly revision.": "Sélectionnez une révision d’assemblage.",
  "Select an exact child revision.": "Sélectionnez une révision exacte du composant.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Sélectionnez au moins une utilisation de composant avant de publier la configuration.",
  "Selected engineering definition": "Définition technique sélectionnée",
  "Selected revision": "Révision sélectionnée",
  "Send this link to": "Envoyez ce lien à",
  "Separable": "Séparable",
  "Separable assembly": "Assemblage démontable",
  "Several parts use this external alias. Search it and choose the correct part.": "Plusieurs pièces portent ce numéro externe. Recherchez-le et choisissez la bonne pièce.",
  "Show V": "Afficher V",
  "Show all company parts": "Afficher toutes les pièces de l’entreprise",
  "Show {column}": "Afficher {column}",
  "Showing the first": "Affichage des premiers",
  "Shown in product version V": "Affiché dans la version produit V",
  "Sign in first.": "Connectez-vous d’abord.",
  "Sign in to continue.": "Connectez-vous pour continuer.",
  "Sign in to your engineering workspace.": "Connectez-vous à votre espace d’ingénierie.",
  "Sign in with the Google account named on this invitation.": "Connectez-vous avec le compte Google nommé dans l’invitation.",
  "Sign out": "Se déconnecter",
  "Signing in…": "Connexion…",
  "Skip to content": "Aller au contenu",
  "Sort": "Tri",
  "Standard position meanings cannot be changed.": "Les significations des positions standard ne peuvent pas être modifiées.",
  "State": "État",
  "Structure": "Structure",
  "Structure snapshot": "Instantané de structure",
  "Structure snapshot not found.": "Instantané de structure introuvable.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Passez à V2 : les mains et axes réutilisés gardent leurs numéros V1. Seule la nouvelle caméra reçoit un numéro V2. ROBOT est le code projet ; V1/V2 sont des versions produit, pas des révisions de pièces.",
  "Switch to {value0} appearance": "Passer au thème {value0}",
  "Table density": "Densité du tableau",
  "That record was not found in this company.": "Cet enregistrement est introuvable dans cette entreprise.",
  "The corrected identifier must differ from the current identifier.": "L’identifiant corrigé doit différer de l’actuel.",
  "The correction creates duplicate identifiers.": "La correction crée des identifiants en double.",
  "The identifier number is outside the supported positive integer range.": "Le numéro d’identifiant dépasse la plage d’entiers positifs prise en charge.",
  "The next number changed. Review the updated preview, then issue again.": "Le prochain numéro a changé. Vérifiez l’aperçu mis à jour, puis réessayez.",
  "The number is allocated within its prefix:": "Le numéro est attribué dans son préfixe :",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "L’ancienne pièce conserve sa fiche. Exemple : le capot de remplacement exige un adaptateur. Le sens inverse n’est pas implicite ; un remplacement n’est pas un alias.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "L’ancienne définition publiée reste accessible ; un numéro non qualifié identifie la pièce, pas la « dernière révision ».",
  "The part is saved in the company registry.": "La pièce est enregistrée dans le registre de l’entreprise.",
  "The pending invitation for": "L’invitation en attente pour",
  "The prefix is ROBOT-V1.2A.": "Le préfixe est ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "La famille apparentée doit avoir la même version produit et le même parent d’origine.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "Requête impossible. Réessayez ou rechargez ; confirmez toute modification en attente avant de modifier à nouveau.",
  "The request could not be read. Check your input and try again.": "Requête illisible. Vérifiez les données et réessayez.",
  "The revision and configuration select different assembly baselines.": "La révision et la configuration sélectionnent des références d’assemblage différentes.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "Même forme de capot : aluminium argenté à gauche, fibre de carbone tissée à droite",
  "The selected part may replace": "La pièce sélectionnée peut remplacer",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "Un numéro de famille commun n’implique pas l’interchangeabilité. « Sans côté » omet le suffixe ; créer un côté ne crée pas l’autre.",
  "This PIN was not found in the selected company.": "Ce PIN est introuvable dans l’entreprise sélectionnée.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "Cette référence utilise plusieurs révisions du composant. Précisez !REV.",
  "This change conflicts with an existing record. Reload and review your changes.": "Cette modification est en conflit avec une fiche existante. Rechargez et vérifiez.",
  "This child revision is not in the selected parent baseline.": "Cette révision de composant n’appartient pas à la référence parente sélectionnée.",
  "This code was registered elsewhere. Review its meaning before using it.": "Ce code a été enregistré ailleurs. Vérifiez sa signification avant utilisation.",
  "This configuration is already released.": "Cette configuration est déjà publiée.",
  "This destination is read-only or the revision is unavailable.": "Destination en lecture seule ou révision indisponible.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "Ce numéro appartient à une autre famille. Créez explicitement une identité apparentée.",
  "This identifier is reserved by a historical rename.": "Cet identifiant est réservé par un renommage historique.",
  "This invitation has expired or been revoked.": "Cette invitation a expiré ou a été révoquée.",
  "This invitation has expired, was replaced, or is no longer pending.": "Invitation expirée, remplacée ou qui n’est plus en attente.",
  "This invitation is no longer pending.": "Cette invitation n’est plus en attente.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "Il s’agit du prochain numéro disponible, non réservé. Il est revérifié à l’attribution. S’il a été pris, le formulaire reste ouvert avec un aperçu actualisé.",
  "This occurrence would create a structure cycle.": "Cette utilisation créerait un cycle dans la structure.",
  "This part number already exists. Choose a different variant or position.": "Ce numéro de pièce existe déjà. Choisissez une autre variante ou position.",
  "This person is already a member. Change their role in Members.": "Cette personne est déjà membre. Modifiez son rôle dans Membres.",
  "This product version number is already assigned.": "Ce numéro de version produit est déjà attribué.",
  "This project code already exists.": "Ce code projet existe déjà.",
  "This record changed. Reload it before saving again.": "La fiche a changé. Rechargez-la avant d’enregistrer.",
  "This released configuration does not exist.": "Cette configuration publiée n’existe pas.",
  "This replacement direction already exists.": "Ce sens de remplacement existe déjà.",
  "This revision does not exist.": "Cette révision n’existe pas.",
  "This revision is already released.": "Cette révision est déjà publiée.",
  "This saved search belongs to another person.": "Cette recherche enregistrée appartient à une autre personne.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "Met à jour les préfixes du projet. Les identités contrôlées conservent leurs redirections historiques.",
  "Time zone": "Fuseau horaire",
  "Try again": "Réessayer",
  "Two hands, two identities.": "Deux mains, deux identités.",
  "Two occurrences, one part": "Deux utilisations, une pièce",
  "Unit": "Unité",
  "Unsaved search": "Recherche non enregistrée",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Utilisez PROJECT-V1 suivi de nœuds d’identité sans zéros initiaux.",
  "Use a positive product version number.": "Utilisez un numéro de version produit positif.",
  "Use a positive, unpadded family number.": "Utilisez un numéro de famille positif sans zéros initiaux.",
  "Use a whole number for the search filter.": "Utilisez un entier pour le filtre de recherche.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Code en majuscules commençant par une lettre, avec lettres, chiffres ou tirets, 32 caractères maximum.",
  "Use code": "Utiliser le code",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Utilisez nombre/type, puis éventuellement !VARIANT et #POSITION, puis !REV et !CFG dans cet ordre. Pas de zéros initiaux ni de qualificatifs avec deux-points.",
  "Using this pin in V2 or another project in the same company keeps": "L’utilisation de cet axe dans V2 ou un autre projet de l’entreprise conserve",
  "V1 tells you where a part was first numbered.": "V1 indique où la pièce a été numérotée pour la première fois.",
  "Variant code": "Code de variante",
  "Variant codes": "Codes de variantes",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Les codes de variante contiennent des majuscules et ne commencent pas par REV ou CFG.",
  "Variants & replacements": "Variantes et remplacements",
  "Version name": "Nom de version",
  "Version name (optional)": "Nom de version (facultatif)",
  "Version number": "Numéro de version",
  "View parts": "Voir les pièces",
  "Viewer": "Lecteur",
  "Wait for a valid part-number preview.": "Attendez un aperçu valide du numéro de pièce.",
  "Welded": "Soudé",
  "Welded assembly": "Assemblage soudé",
  "Welded torso frame": "Cadre de torse soudé",
  "Where used": "Utilisations",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "Avec des dépendances contrôlées, l’ancien texte redirige vers la pièce renommée. !REV1 reste la révision historique exacte ; configurations et numérotation des descendants sont conservées.",
  "Withdraw permission for": "Retirer l’autorisation à",
  "Withdraw replacement": "Retirer le remplacement",
  "Withdraw replacement?": "Retirer le remplacement ?",
  "You are already a member of this company.": "Vous êtes déjà membre de cette entreprise.",
  "Your form session expired. Refresh your session, then retry the saved change.": "La session du formulaire a expiré. Actualisez-la, puis réessayez la modification conservée.",
  "Your preferences changed. Reload before saving again.": "Vos préférences ont changé. Rechargez-les avant d’enregistrer.",
  "across this company": "dans toute l’entreprise",
  "and": "et",
  "at {value0}": "à {value0}",
  "dark": "sombre",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "distinguent les formes droite et gauche. Les repères indiquent les mains du robot, pas les côtés de l’observateur.",
  "from": "de",
  "from this structure? The original part remains in the company registry.": "de cette structure ? La pièce d’origine reste dans le registre de l’entreprise.",
  "in this example.": "dans cet exemple.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "est le type de construction, pas une révision. P est une pièce sans composants contrôlés ; A, W, G et R sont des assemblages joints différemment.",
  "issued.": "attribué.",
  "light": "clair",
  "match": "résultat",
  "matches": "résultats",
  "mm": "mm",
  "of": "de",
  "only under the stated conditions.": "uniquement dans les conditions indiquées.",
  "parts. Search the company to find additional matches.": "pièces. Recherchez dans l’entreprise pour d’autres résultats.",
  "to replace": "pour remplacer",
  "will lose access to every project and part in this company.": "perdra l’accès à tous les projets et pièces de cette entreprise.",
  "will no longer work.": "ne fonctionnera plus.",
  "{field} must contain {minimum}–{maximum} characters.": "{field} doit contenir entre {minimum} et {maximum} caractères.",
  "{value0} added to {value1}.": "{value0} ajouté à {value1}.",
  "{value0} code": "Code {value0}",
  "{value0} cover example": "Exemple de capot {value0}",
  "{value0} editor": "Éditeur {value0}",
  "{value0} meaning": "Signification {value0}",
  "{value0} · Rev {value1}": "{value0} · Rév. {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· 1 pièce chacun",
  "· Refine your search for other matches.": "· Affinez la recherche pour d’autres résultats.",
  "· Revision {value0}": "· Révision {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF change l’identité, pas la révision.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "? Sa définition et ses utilisations exactes deviennent immuables. Toute modification nécessitera une nouvelle révision.",
  "Accept invitation": "Accepter l’invitation",
  "Accepting…": "Acceptation…",
  "Actions": "Actions",
  "Actions for {value0}": "Actions pour {value0}",
  "Add description": "Ajouter une description",
  "Add external alias": "Ajouter un numéro externe",
  "An origin parent is selected.": "Un parent d’origine est sélectionné.",
  "Applicability / effectivity": "Applicabilité / validité",
  "Apply identity correction": "Appliquer la correction d’identité",
  "Assembly revision": "Révision d’assemblage",
  "Both covers share": "Les deux capots partagent",
  "Change role": "Changer le rôle",
  "Checking number…": "Vérification du numéro…",
  "Child REV": "Rév. du composant",
  "Choose a project": "Choisir un projet",
  "Choose a revision to inspect its exact definition.": "Choisissez une révision pour voir sa définition exacte.",
  "Choose a revision to view its exact structure.": "Choisissez une révision pour voir sa structure exacte.",
  "Choose an assembly in the selected product version.": "Choisissez un assemblage de cette version produit.",
  "Choose an exact assembly revision.": "Choisissez une révision exacte d’assemblage.",
  "Choose another company": "Choisir une autre entreprise",
  "Collapse": "Réduire",
  "Company access unavailable": "Accès à l’entreprise indisponible",
  "Copied.": "Copié.",
  "Copy link": "Copier le lien",
  "Copy was unavailable. Select the link and copy it manually.": "Copie indisponible. Sélectionnez le lien et copiez-le manuellement.",
  "Correct identity": "Corriger l’identité",
  "Custom position…": "Position personnalisée…",
  "Definition": "Définition",
  "Details for {value0}": "Détails de {value0}",
  "Edit": "Modifier",
  "Edit alias {value}": "Modifier le numéro externe {value}",
  "Edit definition": "Modifier la définition",
  "Edit external alias": "Modifier le numéro externe",
  "Empty definition": "Définition vide",
  "Expand": "Développer",
  "Family number": "Numéro de famille",
  "Freeze CFG": "Figer CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "La connexion Google n’est pas configurée. L’administrateur doit restaurer sa configuration.",
  "Identity": "Identité",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "Dans cet exemple, CF signifie « fibre de carbone ». D’autres entreprises peuvent définir un autre sens.",
  "Include selected revision": "Inclure la révision sélectionnée",
  "Invitations": "Invitations",
  "Join": "Assemblage",
  "Left": "Gauche",
  "Next": "Suivant",
  "No child parts.": "Aucune pièce enfant.",
  "No companies yet.": "Aucune entreprise pour le moment.",
  "No configurations yet.": "Aucune configuration pour le moment.",
  "No external aliases.": "Aucun numéro externe.",
  "No invitations.": "Aucune invitation.",
  "No matching choices.": "Aucun choix correspondant.",
  "No matching parts.": "Aucune pièce correspondante.",
  "No parts in this structure yet.": "Aucune pièce dans cette structure pour le moment.",
  "No product versions in this project.": "Aucune version produit dans ce projet.",
  "No product versions yet.": "Aucune version produit pour le moment.",
  "No projects yet.": "Aucun projet pour le moment.",
  "No replacement relationships.": "Aucune relation de remplacement.",
  "No variant code": "Aucun code de variante",
  "No variant codes registered.": "Aucun code de variante enregistré.",
  "Not reserved": "Non réservé",
  "Numbered directly under the product version.": "Numéroté directement sous la version produit.",
  "Open assembly {value0}": "Ouvrir l’assemblage {value0}",
  "Open resolved configuration": "Ouvrir la configuration résolue",
  "Origin product version": "Version produit d’origine",
  "Other positions": "Autres positions",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Les autres positions ajoutent un qualificatif : #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR et #TOP/#MIDVERT/#BOTTOM. Les deux milieux appartiennent à des axes différents. Les codes personnalisés sont définis par l’entreprise. Ce n’est pas la position d’utilisation d’une pièce dans un assemblage.",
  "Other positions…": "Autres positions…",
  "Page {page} of {pages}": "Page {page} sur {pages}",
  "Part / P/N": "Pièce / numéro",
  "Part section not found.": "Section de pièce introuvable.",
  "Parts in {value0}": "Pièces dans {value0}",
  "Person": "Personne",
  "Piece parts have no child structure.": "Les pièces élémentaires n’ont pas de sous-structure.",
  "Position for occurrence {value0}": "Position de l’utilisation {value0}",
  "Previous": "Précédent",
  "Product root": "Racine du produit",
  "Product structure": "Structure produit",
  "Qty": "Qté",
  "Quantity for occurrence {value0}": "Quantité de l’utilisation {value0}",
  "Quantity for {value0} {value1}": "Quantité pour {value0} {value1}",
  "Quantity saved for {value0}.": "Quantité de {value0} enregistrée.",
  "Read-only access": "Accès en lecture seule",
  "Reason for correction": "Motif de correction",
  "Registered variant": "Variante enregistrée",
  "Release": "Publier",
  "Release revision": "Publier la révision",
  "Remove alias {value}": "Retirer le numéro externe {value}",
  "Remove from assembly {value0} {value1}": "Retirer {value0} {value1} de l’assemblage",
  "Remove selected occurrence": "Retirer l’utilisation sélectionnée",
  "Remove {value0}'s access": "Retirer l’accès de {value0}",
  "Replace invitation link for {value0}": "Remplacer le lien d’invitation de {value0}",
  "Reset quantity for {value0}": "Réinitialiser la quantité de {value0}",
  "Resolved definition: REV": "Définition résolue : REV",
  "Results: {count}": "Résultats : {count}",
  "Retry preview": "Réessayer l’aperçu",
  "Revoke": "Révoquer",
  "Revoke invitation for {value0}": "Révoquer l’invitation de {value0}",
  "Right": "Droite",
  "Role": "Rôle",
  "Same family number, different identities.": "Même numéro de famille, identités différentes.",
  "Save quantity for {value0}": "Enregistrer la quantité de {value0}",
  "Search pages": "Pages de recherche",
  "Source product version": "Version produit source",
  "Source project": "Projet source",
  "Start from": "Commencer par",
  "Structural class": "Type de construction",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "Invitation créée, mais son lien unique ne peut plus être affiché. Utilisez « Remplacer le lien » pour en générer un autre.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "Lien d’invitation incomplet. Demandez un nouveau lien au propriétaire de l’entreprise.",
  "This part is not used in a structure or configuration.": "Cette pièce n’est utilisée dans aucune structure ni configuration.",
  "This structure is read-only. Choose a draft revision to edit.": "Structure en lecture seule. Choisissez une révision brouillon pour la modifier.",
  "Unit & position": "Unité et position",
  "Unit for occurrence {value0}": "Unité de l’utilisation {value0}",
  "Unspecified": "Non précisé",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Les attributions inutilisées sont corrigées directement. Les identités contrôlées sont renommées atomiquement avec redirections historiques ; révisions, configurations et utilisations restent liées.",
  "Use product-version root": "Utiliser la racine de version produit",
  "Variant": "Variante",
  "Versions": "Versions",
  "You do not have company access yet. Open an invitation from a company owner.": "Vous n’avez pas encore accès à une entreprise. Ouvrez l’invitation d’un propriétaire.",
  "Your account does not have access to this company.": "Votre compte n’a pas accès à cette entreprise.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "et ses révisions exactes de composants ? L’assemblage et toutes les révisions doivent déjà être publiés.",
  "as": "comme",
  "because the new cover was explicitly numbered as related to the existing one.": "car le nouveau capot a été explicitement numéroté comme apparenté à l’existant.",
  "may replace": "peut remplacer",
  "using": "avec",
  "· Expires": "· Expire",
  "Sign in again": "Se reconnecter",
  "Refresh session": "Actualiser la session",
  "Connection interrupted. Check the saved change before making another edit.": "Connexion interrompue. Vérifiez la modification conservée avant toute nouvelle modification.",
  "The request could not be completed.": "La requête n’a pas pu aboutir.",
  "Resolve the saved change shown above before making another edit.": "Résolvez la modification conservée avant d’en faire une autre.",
  "Browser storage is unavailable. Enable it before saving a change.": "Stockage du navigateur indisponible. Activez-le avant d’enregistrer.",
  "No position": "Aucune position",
  "Not specified.": "Non précisé.",
  "No description.": "Aucune description.",
  "Field": "Champ",
  "Choose…": "Choisir…",
  "Choose": "Choisir",
  "Complete {field}.": "Renseignez {field}.",
  "Check the value of {field}.": "Vérifiez la valeur de {field}.",
  "Do not submit another edit until this change is confirmed.": "N’envoyez pas d’autre modification avant confirmation de celle-ci.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 garde le capot REV1 ; CFG2 choisit REV2. Une configuration n’est pas un nouveau numéro et ne concerne que les assemblages.",
  "No variant": "Aucune variante",
  "Company created": "Entreprise créée",
  "Company updated": "Entreprise mise à jour",
  "Variant code registered": "Code de variante enregistré",
  "Position code registered": "Code de position enregistré",
  "Role changed": "Rôle modifié",
  "Membership removed": "Membre retiré",
  "Invitation created": "Invitation créée",
  "Invitation link replaced": "Lien d’invitation remplacé",
  "Invitation revoked": "Invitation révoquée",
  "Invitation accepted": "Invitation acceptée",
  "Revision created": "Révision créée",
  "Revision definition updated": "Définition de révision mise à jour",
  "Revision released": "Révision publiée",
  "Structure occurrence added": "Utilisation de pièce ajoutée",
  "Structure occurrence updated": "Utilisation de pièce mise à jour",
  "Structure occurrence removed": "Utilisation de pièce retirée",
  "Configuration created": "Configuration créée",
  "Configuration updated": "Configuration mise à jour",
  "Configuration released": "Configuration publiée",
  "Replacement recorded": "Remplacement enregistré",
  "Replacement withdrawn": "Remplacement retiré",
  "Project created": "Projet créé",
  "Project updated": "Projet mis à jour",
  "Product version created": "Version produit créée",
  "Product version updated": "Version produit mise à jour",
  "Part issued": "Numéro de pièce attribué",
  "Part details updated": "Détails de pièce mis à jour",
  "alias-added": "Numéro externe ajouté",
  "alias-edited": "Numéro externe modifié",
  "alias-removed": "Numéro externe retiré",
  "Identity renamed": "Identité renommée",
  "Assignment corrected": "Attribution corrigée",
  "North": "Nord",
  "South": "Sud",
  "West": "Ouest",
  "East": "Est",
  "Front": "Avant",
  "Rear": "Arrière",
  "Mid": "Milieu",
  "Top": "Haut",
  "Bottom": "Bas",
  "Side": "Côté",
  "North / south": "Nord / sud",
  "West / east": "Ouest / est",
  "Front / rear": "Avant / arrière",
  "Top / bottom": "Haut / bas",
  "Custom": "Personnalisé",
  "Family, not an orderable P/N": "Famille, pas un numéro commandable",
  "Pending": "En attente",
  "Accepted": "Acceptée",
  "Revoked": "Révoquée",
  "Expired": "Expirée",
  "Edit revision definition": "Modifier la définition de révision",
  "Release revision?": "Publier la révision ?",
  "Release configuration?": "Publier la configuration ?",
  "A complete SHA-256 checksum is required.": "Une somme de contrôle SHA-256 complète est requise.",
  "Add comment": "Ajouter un commentaire",
  "Add file": "Ajouter un fichier",
  "All": "Tous",
  "Applicability": "Applicabilité",
  "Applicability must refer to a configuration of the owning part.": "L’applicabilité doit faire référence à une configuration de la pièce à laquelle appartient le document.",
  "Applicability must refer to a revision of the owning part.": "L’applicabilité doit faire référence à une révision de la pièce à laquelle appartient le document.",
  "Applicability notes": "Notes d’applicabilité",
  "Attachment": "Pièce jointe",
  "Cancel upload": "Annuler le téléversement",
  "Cancelled": "Annulé",
  "Checking file…": "Vérification du fichier…",
  "Choose Draft or Issued status.": "Choisissez le statut « Brouillon » ou « Publiée ».",
  "Choose Source, Rendition or Attachment.": "Choisissez « Source », « Version de consultation » ou « Pièce jointe ».",
  "Choose a draft document or production job for this file.": "Choisissez un brouillon de document ou un ordre de fabrication pour ce fichier.",
  "Choose a file of this revision.": "Choisissez un fichier de cette révision.",
  "Choose a registered document type.": "Choisissez un type de document enregistré.",
  "Choose a supported document owner.": "Choisissez un propriétaire de document pris en charge.",
  "Choose a valid results page and a positive page size.": "Choisissez une page de résultats valide et un nombre de résultats par page strictement positif.",
  "Choose an issued revision of this document.": "Choisissez une révision publiée de ce document.",
  "Choose the viewed revision of this document.": "Choisissez la révision de ce document que vous consultez.",
  "Choose this company as the document owner.": "Choisissez cette entreprise comme propriétaire du document.",
  "Clear applicability references": "Effacer les références d’applicabilité",
  "Comment": "Commentaire",
  "Comment history": "Historique du commentaire",
  "Comment removed": "Commentaire supprimé",
  "Copy this revision into a shared editable draft?": "Copier cette révision dans un brouillon partagé et modifiable ?",
  "Create document": "Créer un document",
  "Create shared draft": "Créer un brouillon partagé",
  "Deleted comments retain their history and cannot be edited.": "L’historique des commentaires supprimés est conservé et ces commentaires ne peuvent plus être modifiés.",
  "Discussion": "Discussion",
  "Document comment added": "Commentaire ajouté au document",
  "Document comment deleted": "Commentaire du document supprimé",
  "Document comment edited": "Commentaire du document modifié",
  "Document created": "Document créé",
  "Document draft created": "Brouillon du document créé",
  "Document draft updated": "Brouillon du document mis à jour",
  "Document file": "Fichier du document",
  "Document file linked": "Fichier lié au document",
  "Document file unlinked": "Lien du fichier avec le document supprimé",
  "Document files published": "Fichiers du document rendus publics",
  "Document files unpublished": "Accès public aux fichiers du document révoqué",
  "Document information": "Informations du document",
  "Document issued": "Document publié",
  "Document number": "Numéro du document",
  "Document reader": "Lecteur de document",
  "Document type": "Type de document",
  "Document type registered": "Type de document enregistré",
  "Documents": "Documents",
  "Download {name}": "Télécharger {name}",
  "Edit comment": "Modifier le commentaire",
  "Edit draft": "Modifier le brouillon",
  "Edit history": "Historique des modifications",
  "Exact engineering applicability": "Applicabilité technique exacte",
  "Exact revision": "Révision exacte",
  "File": "Fichier",
  "File name": "Nom du fichier",
  "File purpose": "Usage du fichier",
  "File size must be between 1 byte and 20 GiB.": "La taille du fichier doit être comprise entre 1 octet et 20 Gio.",
  "File storage is not configured.": "Le stockage des fichiers n’est pas configuré.",
  "File unavailable": "Fichier indisponible",
  "Files": "Fichiers",
  "Files available to anyone with the public link": "Fichiers accessibles à toute personne disposant du lien public",
  "Files can only be added to a draft document.": "Les fichiers ne peuvent être ajoutés qu’à un brouillon de document.",
  "Identifier filter": "Filtre par identifiant",
  "Issue revision": "Publier la révision",
  "Issue this exact revision? Its metadata and files will become immutable.": "Publier cette révision exacte ? Ses métadonnées et ses fichiers ne pourront plus être modifiés.",
  "Issued": "Publiée",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Les révisions publiées sont immuables. Créez un brouillon partagé pour apporter des modifications.",
  "Link at least one verified file before issuing.": "Liez au moins un fichier vérifié avant la publication.",
  "New file": "Nouveau fichier",
  "No comments yet.": "Aucun commentaire pour le moment.",
  "No files in this revision.": "Cette révision ne contient aucun fichier.",
  "No published files.": "Aucun fichier rendu public.",
  "No revisions available.": "Aucune révision disponible.",
  "Only an unfinished upload can be cancelled.": "Seul un téléversement inachevé peut être annulé.",
  "Only issued files can be published.": "Seuls les fichiers des révisions publiées peuvent être rendus publics.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Seuls les fichiers immuables dont la taille et la somme SHA-256 ont été vérifiées peuvent être liés ou publiés.",
  "Open public link": "Ouvrir le lien public",
  "Owner kind": "Type de propriétaire",
  "Page {page} · {count} documents": "Page {page} · Documents : {count}",
  "Part revision": "Révision de la pièce",
  "Pause": "Suspendre",
  "Paused": "Suspendu",
  "Preview is not available for this file. Download it instead.": "L’aperçu de ce fichier n’est pas disponible. Téléchargez-le.",
  "Preview unavailable. Download the file to view it.": "Aperçu indisponible. Téléchargez le fichier pour le consulter.",
  "Public description": "Description publique",
  "Public links": "Liens publics",
  "Public title": "Titre public",
  "Publication not found.": "Partage public introuvable.",
  "Publish selected files": "Rendre publics les fichiers sélectionnés",
  "Published document not found.": "Document public introuvable.",
  "Published file not found.": "Fichier public introuvable.",
  "Register document type": "Enregistrer un type de document",
  "Reload revision": "Recharger la révision",
  "Remove comment": "Supprimer le commentaire",
  "Remove file": "Retirer le fichier",
  "Remove this comment? Its edit history is retained.": "Supprimer ce commentaire ? Son historique de modifications sera conservé.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "Retirer ce fichier du brouillon ? Les révisions déjà publiées conserveront leurs fichiers.",
  "Remove {name}": "Retirer {name}",
  "Rendition": "Version de consultation",
  "Resume this upload with the recorder who started it.": "Reprenez ce téléversement avec la personne chargée de la saisie qui l’a lancé.",
  "Resume upload": "Reprendre le téléversement",
  "Revision unavailable": "Révision indisponible",
  "Revision {number}": "Révision {number}",
  "Revision {number} · {status}": "Révision {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Rechercher des documents",
  "Select distinct issued files to publish.": "Sélectionnez des fichiers distincts d’une révision publiée à rendre publics.",
  "Select files from this exact issued revision.": "Sélectionnez des fichiers de cette révision publiée exacte.",
  "Select the same file to resume this upload.": "Sélectionnez le même fichier pour reprendre ce téléversement.",
  "Source": "Source",
  "Status": "Statut",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "Révoquer l’accès via ce lien public ? Les copies déjà téléchargées ne seront pas supprimées.",
  "That document revision was not found in this company.": "Cette révision du document est introuvable dans cette entreprise.",
  "The configuration must select the exact applicability revision.": "La configuration doit sélectionner la révision exacte indiquée par l’applicabilité.",
  "The document input changed during capture. Retry the same request.": "Les données du document ont changé pendant la saisie. Réessayez la même requête.",
  "The file upload is not complete.": "Le téléversement du fichier n’est pas terminé.",
  "The issued files no longer match their immutable manifest.": "Les fichiers publiés ne correspondent plus à leur manifeste immuable.",
  "The issued manifest failed integrity verification.": "La vérification de l’intégrité du manifeste publié a échoué.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "La somme de contrôle du fichier téléversé ne correspond pas. Annulez ce téléversement et sélectionnez à nouveau le fichier d’origine.",
  "The uploaded file is unavailable.": "Le fichier téléversé est indisponible.",
  "The verified file must belong to this document.": "Le fichier vérifié doit appartenir à ce document.",
  "This comment is already deleted.": "Ce commentaire a déjà été supprimé.",
  "This document already has a shared draft.": "Ce document possède déjà un brouillon partagé.",
  "This document numbering sequence is exhausted.": "La séquence de numérotation de ces documents est épuisée.",
  "This file is not available.": "Ce fichier n’est pas disponible.",
  "This file is unavailable. Contact the company owner.": "Ce fichier est indisponible. Contactez le propriétaire de l’entreprise.",
  "This revision changed. Reload it before publishing.": "Cette révision a changé. Rechargez-la avant de rendre ses fichiers publics.",
  "This upload cannot be verified.": "Ce téléversement ne peut pas être vérifié.",
  "This upload is no longer writable.": "Il n’est plus possible d’écrire des données dans ce téléversement.",
  "This upload was not found.": "Ce téléversement est introuvable.",
  "Title": "Titre",
  "Title filter": "Filtre par titre",
  "Type code": "Code du type",
  "Type name": "Nom du type",
  "Unpublish": "Révoquer l’accès public",
  "Unpublished": "Accès public révoqué",
  "Upload file": "Téléverser un fichier",
  "Uploaded": "Téléversé",
  "Uploading…": "Téléversement…",
  "Use a file name without a path or control characters.": "Utilisez un nom de fichier sans chemin ni caractères de contrôle.",
  "Use a file name without directory separators.": "Utilisez un nom de fichier sans séparateurs de répertoires.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Utilisez un code de type composé de lettres latines majuscules et de chiffres, commençant par une lettre.",
  "Verified": "Vérifié",
  "Verifying file…": "Validation du fichier…",
  "View draft": "Consulter le brouillon",
  "file-upload-created": "Téléversement du fichier créé",
  "file-verified": "Fichier vérifié",
  "{bytes} bytes": "{bytes} octets",
  "No matching documents.": "Aucun document correspondant.",
  "No documents yet.": "Aucun document pour le moment.",
  "The revision’s applicability details could not be loaded. Try again.": "Impossible de charger les détails d’applicabilité de la révision. Réessayez.",
  "Comment authors could not be loaded. Try again.": "Impossible de charger les auteurs des commentaires. Réessayez.",
  "Comment history authors could not be loaded. Try again.": "Impossible de charger les auteurs des modifications du commentaire. Réessayez.",
  "Choose a saved search": "Choisir une recherche enregistrée",
  "This saved search belongs to another person or collection.": "Cette recherche enregistrée appartient à une autre personne ou collection.",
  "Choose a saved parts search.": "Choisissez une recherche de pièces enregistrée.",
  "Supply document search filters.": "Indiquez les filtres de recherche de documents.",
  "Pages": "Pages",
  "{from}–{to} of {total}": "{from}–{to} sur {total}",
  "Choose lot": "Choisir un lot",
  "Choose material": "Choisir un matériau",
  "No matches": "Aucune correspondance",
  "Stock": "Stocks",
  "Lots": "Lots",
  "Materials": "Matériaux",
  "Supplier": "Fournisseur",
  "Material identifier": "Identifiant du matériau",
  "Specification": "Spécification",
  "Reload latest versions": "Recharger les dernières versions",
  "Edit material": "Modifier le matériau",
  "Create material revision": "Créer une révision du matériau",
  "Edit material revision": "Modifier la révision du matériau",
  "Release material revision": "Publier la révision du matériau",
  "Create lot": "Créer un lot",
  "Choose an exact material revision.": "Choisissez une révision précise du matériau.",
  "Lot identifier": "Identifiant du lot",
  "Balances": "Soldes de stock",
  "No stock recorded": "Aucun stock enregistré",
  "Genealogy": "Généalogie des lots",
  "No linked lots": "Aucun lot lié",
  "To": "Vers",
  "Reversed": "Contrepassé",
  "Movement details": "Détails du mouvement",
  "Record history": "Historique de l’enregistrement",
  "Movements": "Mouvements de stock",
  "Movement type": "Type de mouvement",
  "No movements recorded": "Aucun mouvement enregistré",
  "Original movement": "Mouvement initial",
  "Replaced movement": "Mouvement remplacé",
  "Reversal": "Contrepassation",
  "Reverse movement": "Contrepasser le mouvement",
  "Record replacement": "Enregistrer le remplacement",
  "Movement warnings unavailable": "Avertissements de mouvement indisponibles",
  "Warnings": "Avertissements",
  "Actual quantity": "Quantité réelle",
  "Location": "Emplacement",
  "Disposition": "Statut de disposition",
  "Use balance location": "Utiliser l’emplacement du stock",
  "Wait for the latest balances.": "Attendez les soldes de stock actualisés.",
  "Choose a lot for every quantity.": "Choisissez un lot pour chaque quantité.",
  "Source {number}": "Source {number}",
  "Remove source": "Retirer la source",
  "Add source": "Ajouter une source",
  "Output {number}": "Sortie {number}",
  "Remove output": "Retirer la sortie",
  "Add output": "Ajouter une sortie",
  "Destination location": "Emplacement de destination",
  "Source reference": "Référence source",
  "Reason": "Motif",
  "Reload latest balances": "Recharger les soldes actualisés",
  "Receipt": "Réception",
  "Accept": "Accepter",
  "Quarantine": "Mettre en quarantaine",
  "Transfer": "Transfert",
  "Consume": "Consommer",
  "Scrap": "Mettre au rebut",
  "Split": "Diviser",
  "Merge": "Fusionner",
  "MaterialLots": "Lots de matériaux",
  "Receipts": "Réceptions",
  "Create material": "Créer un matériau",
  "Search lots": "Rechercher des lots",
  "Search materials": "Rechercher des matériaux",
  "Select a lot": "Sélectionnez un lot",
  "Select a material": "Sélectionnez un matériau",
  "Supplier reference": "Référence fournisseur",
  "Supplier lot reference": "Référence du lot fournisseur",
  "Material created": "Matériau créé",
  "Material renamed": "Matériau renommé",
  "Material revision created": "Révision du matériau créée",
  "Material revision edited": "Révision du matériau modifiée",
  "Material revision released": "Révision du matériau publiée",
  "Lot created": "Lot créé",
  "Correction": "Correction",
  "Record updated": "Enregistrement mis à jour",
  "All movements": "Tous les mouvements",
  "Quarantined": "En quarantaine",
  "Not recorded": "Non enregistré",
  "No matching records.": "Aucun enregistrement correspondant.",
  "Page": "Page",
  "Evidence warnings": "Avertissements sur les justificatifs",
  "Production": "Production",
  "Create job": "Créer un ordre de fabrication",
  "Routes": "Gammes de fabrication",
  "Search jobs": "Rechercher des ordres de fabrication",
  "Clear part filter": "Effacer le filtre de pièces",
  "No jobs found.": "Aucun ordre de fabrication trouvé.",
  "Select a job to review or record actual work.": "Sélectionnez un ordre pour consulter ou enregistrer le travail réel.",
  "Change": "Changer",
  "Select an exact definition revision.": "Sélectionnez une révision précise de la définition.",
  "Job identifier": "Identifiant de l’ordre",
  "Route input": "Gamme en entrée",
  "Document inputs": "Documents d’entrée",
  "Select route": "Sélectionner une gamme",
  "Back": "Retour",
  "Create route": "Créer une gamme",
  "Create route revision": "Créer une révision de gamme",
  "Choose another route": "Choisir une autre gamme",
  "Inspection expected": "Contrôle prévu",
  "Route name": "Nom de la gamme",
  "Operation": "Opération",
  "Instructions": "Instructions",
  "Move up": "Monter",
  "Move down": "Descendre",
  "Remove operation": "Retirer l’opération",
  "Add operation": "Ajouter une opération",
  "Serials": "Unités sérialisées",
  "ProductionOutputs": "Sorties de production",
  "Operations": "Opérations",
  "Inspections": "Contrôles",
  "Declarations": "Déclarations",
  "Back to collection": "Retour à la liste",
  "Recorded at": "Enregistré le",
  "Created": "Créé",
  "Display columns": "Colonnes affichées",
  "Import records": "Importer des enregistrements",
  "Preview records": "Prévisualiser les enregistrements",
  "New preview": "Nouvel aperçu",
  "Apply valid rows": "Appliquer les lignes valides",
  "Reload preview": "Recharger l’aperçu",
  "Row {number}": "Ligne {number}",
  "Applied": "Appliqué",
  "Apply row": "Appliquer la ligne",
  "Source name": "Nom de la source",
  "Record type": "Type d’enregistrement",
  "Download CSV template": "Télécharger le modèle CSV",
  "CSV file": "Fichier CSV",
  "Previous imports": "Importations précédentes",
  "Manual entry": "Saisie manuelle",
  "Choose a CSV file.": "Choisissez un fichier CSV.",
  "The CSV file exceeds the import size limit.": "Le fichier CSV dépasse la taille maximale d’importation.",
  "Serial number": "Numéro de série",
  "Output source reference": "Référence source de la sortie",
  "Step": "Étape",
  "Result": "Résultat",
  "Actual result": "Résultat réel",
  "Kind": "Nature",
  "Value": "Valeur",
  "Exact configuration": "Configuration précise",
  "Exact route revision": "Révision précise de la gamme",
  "Material definition": "Définition du matériau",
  "Primary definition": "Définition principale",
  "Route revision": "Révision de gamme",
  "Record output": "Enregistrer une sortie",
  "Record operation": "Enregistrer une opération",
  "Record inspection": "Enregistrer un contrôle",
  "Record consumption or component": "Enregistrer une consommation ou un composant",
  "Declare output": "Déclarer l’état de la sortie",
  "Capture as-built": "Capturer la configuration réalisée",
  "Unnamed record": "Enregistrement sans nom",
  "Serial": "Numéro de série",
  "None available": "Aucun disponible",
  "The selected job was not found in an editable company.": "L’ordre sélectionné est introuvable dans une entreprise que vous pouvez modifier.",
  "Offline job": "Ordre hors ligne",
  "Download selected job": "Télécharger l’ordre sélectionné",
  "Offline work": "Travail hors ligne",
  "Selected job and files saved for offline use.": "L’ordre sélectionné et ses fichiers sont enregistrés pour une utilisation hors ligne.",
  "Download": "Télécharger",
  "bytes": "octets",
  "Find material lots": "Rechercher des lots de matériaux",
  "Find component parts": "Rechercher des pièces composantes",
  "Correct recorded work": "Corriger le travail enregistré",
  "Save correction": "Enregistrer la correction",
  "Save offline": "Enregistrer hors ligne",
  "Wait for evidence to finish saving.": "Attendez la fin de l’enregistrement des justificatifs.",
  "Choose an output with a recorded version.": "Choisissez une sortie avec une version enregistrée.",
  "Reconnect and load current records before saving a correction.": "Reconnectez-vous et chargez les enregistrements actuels avant de sauvegarder une correction.",
  "Confirm that this correction uses the current stock version.": "Confirmez que cette correction utilise la version actuelle du stock.",
  "The original recording is retained. Review current records before submitting a separate correction.": "L’enregistrement initial est conservé. Consultez les enregistrements actuels avant de soumettre une correction distincte.",
  "Loading current records": "Chargement des enregistrements actuels",
  "Current stock": "Stock actuel",
  "Completed": "Terminé",
  "Failed": "Échec",
  "Skipped": "Ignoré",
  "InProgress": "En cours",
  "Passed": "Réussi",
  "Inconclusive": "Non concluant",
  "I reviewed the stock conflict and authorize this correction against current stock.": "J’ai examiné le conflit de stock et j’autorise cette correction sur la base du stock actuel.",
  "Quality": "Qualité",
  "NotStarted": "Non commencé",
  "Rejected": "Rejeté",
  "As-built": "Configuration réalisée",
  "Evidence file": "Fichier justificatif",
  "Saving evidence locally": "Enregistrement local des justificatifs",
  "The correction retains the original evidence attachments.": "La correction conserve les pièces justificatives initiales.",
  "Reconnect to verify recorder access before continuing.": "Reconnectez-vous pour vérifier l’accès de la personne chargée de l’enregistrement avant de continuer.",
  "Reconnect as the original offline recorder.": "Reconnectez-vous avec le compte utilisé pour l’enregistrement hors ligne initial.",
  "Offline recording access was revoked. Recorded work is retained.": "L’accès à l’enregistrement hors ligne a été révoqué. Le travail enregistré est conservé.",
  "Reconnect": "Se reconnecter",
  "Loading": "Chargement",
  "No offline job is open. Download a selected production job while connected.": "Aucun ordre hors ligne n’est ouvert. Téléchargez un ordre de fabrication lorsque vous êtes connecté.",
  "Selected job": "Ordre sélectionné",
  "Online": "En ligne",
  "Offline": "Hors ligne",
  "Resume download": "Reprendre le téléchargement",
  "Synchronize": "Synchroniser",
  "Close offline session": "Fermer la session hors ligne",
  "Captured operations": "Opérations capturées",
  "No route captured": "Aucune gamme capturée",
  "Recorded inspections": "Contrôles enregistrés",
  "Outputs": "Sorties",
  "No outputs recorded": "Aucune sortie enregistrée",
  "Downloaded files": "Fichiers téléchargés",
  "Material lots": "Lots de matériaux",
  "Record work": "Enregistrer le travail",
  "Recorded commands": "Actions enregistrées",
  "No local commands recorded": "Aucune action locale enregistrée",
  "Retained original; correction recorded": "Original conservé ; correction enregistrée",
  "Retry unchanged": "Réessayer sans modification",
  "Saved evidence": "Justificatifs enregistrés",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Fermez uniquement après acceptation de tout le travail enregistré et de ses justificatifs. L’historique local reste accessible.",
  "Offline storage is unavailable in this browser.": "Le stockage hors ligne n’est pas disponible dans ce navigateur.",
  "The offline application could not be downloaded. Try again online.": "L’application hors ligne n’a pas pu être téléchargée. Réessayez en ligne.",
  "The offline application is not ready. Reload online and try again.": "L’application hors ligne n’est pas prête. Rechargez en ligne et réessayez.",
  "An offline update is waiting. Close other registry tabs and reload online.": "Une mise à jour hors ligne est en attente. Fermez les autres onglets du registre et rechargez en ligne.",
  "Verified files": "Fichiers vérifiés",
  "Component part": "Pièce composante",
  "Component serials": "Composants sérialisés",
  "Output": "Sortie",
  "Reserved serial": "Unité sérialisée réservée",
  "Output lot": "Lot de sortie",
  "Operation order": "Ordre de l’opération",
  "Shared run": "Exécution de production commune",
  "Rework of": "Reprise de",
  "Inspection": "Contrôle",
  "Actual": "Valeur réelle",
  "Operation attempt": "Tentative d’opération",
  "Material lot": "Lot de matériau",
  "Component serial": "Composant sérialisé",
  "Actual revision": "Révision réelle",
  "Declaration": "Déclaration",
  "Declared state": "État déclaré",
  "Amends snapshot": "Modifie l’instantané",
  "Attach saved evidence": "Joindre les justificatifs enregistrés",
  "preparing": "Préparation",
  "downloading": "Téléchargement",
  "ready": "Prêt",
  "rejected": "Rejeté",
  "closed": "Fermé",
  "pending": "En attente",
  "sending": "Envoi",
  "accepted": "Accepté",
  "conflict": "Conflit",
  "staged": "Stocké localement",
  "uploading": "Téléversement",
  "verified": "Vérifié",
  "attached": "Joint",
  "Captured inputs": "Entrées capturées",
  "Captured route": "Gamme capturée",
  "Planned components": "Composants prévus",
  "No planned components.": "Aucun composant prévu.",
  "No file evidence recorded.": "Aucun fichier justificatif enregistré.",
  "Evidence files": "Fichiers justificatifs",
  "Actual outputs": "Sorties réelles",
  "No actual outputs recorded.": "Aucune sortie réelle enregistrée.",
  "Operations and inspections": "Opérations et contrôles",
  "Create shared run": "Créer une exécution de production commune",
  "Record rework": "Enregistrer une reprise",
  "No operations or inspections recorded.": "Aucune opération ni aucun contrôle enregistré.",
  "Actual components and lots": "Composants et lots réels",
  "Record component or lot": "Enregistrer un composant ou un lot",
  "No actual components recorded.": "Aucun composant réel enregistré.",
  "Job documents": "Documents de l’ordre",
  "Whole job": "Ordre entier",
  "Actual component": "Composant réel",
  "Unserialized output": "Sortie non sérialisée",
  "Not declared": "Non déclaré",
  "Declare production": "Déclarer l’état de production",
  "Declare quality": "Déclarer l’état de qualité",
  "Amend as-built": "Modifier la configuration réalisée",
  "Declaration history": "Historique des déclarations",
  "As-built history": "Historique de la configuration réalisée",
  "Snapshot": "Instantané",
  "Choose a declaration.": "Choisissez une déclaration.",
  "As-built snapshot": "Instantané de la configuration réalisée",
  "Actual output": "Sortie réelle",
  "No serialized units found.": "Aucune unité sérialisée trouvée.",
  "Serialized output": "Sortie sérialisée",
  "Clear": "Effacer",
  "Choose a result.": "Choisissez un résultat.",
  "Inspection name": "Nom du contrôle",
  "Use shared run": "Utiliser une exécution commune",
  "This job is not part of this shared run.": "Cet ordre ne fait pas partie de cette exécution commune.",
  "Choose another run": "Choisir une autre exécution",
  "Run identifier": "Identifiant de l’exécution",
  "Serialized unit": "Unité sérialisée",
  "Select the actual component or lot.": "Sélectionnez le composant ou le lot réel.",
  "Serial units": "Unités sérialisées",
  "Allocate serials": "Attribuer des numéros de série",
  "Import serial labels": "Importer des identifiants de série",
  "Void": "Invalider",
  "Void serial": "Invalider le numéro de série",
  "Reprint label": "Réimprimer l’étiquette",
  "Enter positive integer serial numbers.": "Saisissez des numéros de série entiers positifs.",
  "Number of serials": "Nombre de numéros de série",
  "Existing serial numbers": "Numéros de série existants",
  "Serial label": "Étiquette de série",
  "Allow pop-ups to print this label.": "Autorisez les fenêtres contextuelles pour imprimer cette étiquette.",
  "Print label": "Imprimer l’étiquette",
  "Lot {lot} uses draft material revision {revision}.": "Le lot {lot} utilise la révision de matériau {revision} à l’état de brouillon.",
  "Consumed quarantined stock: {lot}.": "Stock en quarantaine consommé : {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Stock insuffisant : {lot} à {location} ({disposition}) ; disponible {available}, sortie enregistrée {outgoing}.",
  "syncing": "Synchronisation",
  "Supply the selected template's values.": "Fournissez les valeurs du modèle sélectionné.",
  "Manual intake contains an unknown column.": "La saisie manuelle contient une colonne inconnue.",
  "A manual value is missing or too long.": "Une valeur saisie manuellement est absente ou trop longue.",
  "Supply CSV text.": "Fournissez le texte CSV.",
  "Supply CSV text of at most 1 MiB.": "Fournissez un texte CSV de 1 Mio maximum.",
  "CSV text cannot contain null characters.": "Le texte CSV ne peut pas contenir de caractères nuls.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "Le CSV dépasse la limite de 1 Mio en UTF-8.",
  "CSV must contain valid UTF-8 text.": "Le CSV doit contenir du texte UTF-8 valide.",
  "The CSV header is missing.": "L’en-tête CSV est absent.",
  "Every header must be unique.": "Chaque en-tête doit être unique.",
  "The template requires this header, even when its values are optional.": "Le modèle exige cet en-tête, même si ses valeurs sont facultatives.",
  "This column is not in the selected template.": "Cette colonne ne figure pas dans le modèle sélectionné.",
  "CSV contains more than 500 data rows.": "Le CSV contient plus de 500 lignes de données.",
  "This row must have exactly the number of fields in the header.": "Cette ligne doit comporter exactement autant de champs que l’en-tête.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Guillemets CSV mal formés ou champ dépassant 16 000 caractères. Corrigez la source et créez un nouvel aperçu.",
  "A source reference may occur only once in a preview.": "Une référence source ne peut apparaître qu’une fois dans un aperçu.",
  "Supply at least one data row.": "Fournissez au moins une ligne de données.",
  "This preview uses an older intake contract. Create a new preview.": "Cet aperçu utilise d’anciennes règles d’importation. Créez un nouvel aperçu.",
  "The selected row does not match this immutable preview.": "La ligne sélectionnée ne correspond pas à cet aperçu immuable.",
  "Correct the CSV errors and create a new preview before applying this row.": "Corrigez les erreurs CSV et créez un nouvel aperçu avant d’appliquer cette ligne.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "Cette ligne source a déjà été appliquée avec d’autres données ou par une autre personne. Elle ne peut pas être écrasée.",
  "This row no longer meets the intake contract. Create a new preview.": "Cette ligne ne respecte plus les règles d’importation. Créez un nouvel aperçu.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Les données référencées ont changé depuis l’aperçu. Consultez les données actuelles et créez un nouvel aperçu ; cette ligne n’a pas été réadaptée automatiquement.",
  "No exact company reference matches this value.": "Aucune référence exacte de cette entreprise ne correspond à cette valeur.",
  "This reference is ambiguous; select an exact source reference.": "Cette référence est ambiguë ; sélectionnez une référence source exacte.",
  "This material identifier already exists; intake does not overwrite definitions.": "Cet identifiant de matériau existe déjà ; l’importation n’écrase pas les définitions.",
  "This lot identifier already exists; intake does not overwrite lots.": "Cet identifiant de lot existe déjà ; l’importation n’écrase pas les lots.",
  "Use the exact material revision unit.": "Utilisez exactement l’unité de la révision du matériau.",
  "Use the exact authored lot unit; stock is not converted.": "Utilisez exactement l’unité définie pour le lot ; le stock n’est pas converti.",
  "The job must produce the exact selected part.": "L’ordre doit produire exactement la pièce sélectionnée.",
  "This serial is already allocated or imported and cannot be reused.": "Ce numéro de série est déjà attribué ou importé et ne peut pas être réutilisé.",
  "A serialized output is exactly one ea.": "Une sortie sérialisée correspond exactement à 1 ea.",
  "A part job cannot declare a material lot output.": "Un ordre de fabrication de pièce ne peut pas déclarer un lot de matériau en sortie.",
  "The operation must exist in the job's captured route.": "L’opération doit exister dans la gamme capturée pour l’ordre.",
  "Select one actual output by its exact source reference.": "Sélectionnez une sortie réelle par sa référence source exacte.",
  "Use at most {maximum} characters.": "Utilisez au maximum {maximum} caractères.",
  "A value is required.": "Une valeur est requise.",
  "Use a positive, unpadded integer.": "Utilisez un entier positif sans zéros initiaux.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Utilisez une quantité décimale positive sans séparateur de milliers, avec au plus six décimales et douze chiffres entiers.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Utilisez un horodatage UTC réel, par exemple 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Choisissez Accepted ou Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Choisissez Completed, Failed, Skipped ou InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Choisissez Passed, Failed ou Inconclusive.",
  "An imported serial requires its complete part PIN.": "Un numéro de série importé nécessite le PIN complet de sa pièce.",
  "Choose Production or Quality.": "Choisissez Production ou Quality.",
  "Choose a declaration value belonging to this kind.": "Choisissez une valeur de déclaration correspondant à cette nature.",
  "This intake preview was not found for this recorder and company.": "Cet aperçu d’importation est introuvable pour cette personne et cette entreprise.",
  "This preview row was not found.": "Cette ligne d’aperçu est introuvable.",
  "Choose a published intake template.": "Choisissez un modèle d’importation publié.",
  "Use an actual UTC timestamp.": "Utilisez un horodatage UTC réel.",
  "This material identifier already exists.": "Cet identifiant de matériau existe déjà.",
  "Released or used definitions stay unchanged. Create a new revision.": "Les définitions publiées ou utilisées restent inchangées. Créez une nouvelle révision.",
  "This material revision is already released.": "Cette révision du matériau est déjà publiée.",
  "Use the exact material revision unit; stock is not converted.": "Utilisez exactement l’unité de la révision du matériau ; le stock n’est pas converti.",
  "This lot identifier already exists.": "Cet identifiant de lot existe déjà.",
  "This lot changed. Reload its balances before recording stock.": "Ce lot a changé. Rechargez ses soldes avant d’enregistrer un mouvement de stock.",
  "Use the lot's exact authored unit; stock is not converted.": "Utilisez exactement l’unité définie pour le lot ; le stock n’est pas converti.",
  "Reverse the original movement before recording its replacement.": "Contrepassez le mouvement initial avant d’enregistrer son remplacement.",
  "This movement already has a replacement.": "Ce mouvement a déjà un remplacement.",
  "This movement has already been corrected.": "Ce mouvement a déjà été corrigé.",
  "Use an exact location without surrounding whitespace.": "Indiquez un emplacement exact sans espaces au début ni à la fin.",
  "Split and merge require the same exact material revision.": "La division et la fusion exigent exactement la même révision du matériau.",
  "Split and merge preserve disposition.": "La division et la fusion conservent le statut de disposition.",
  "Split and merge quantities must match exactly.": "Les quantités lors d’une division ou fusion doivent correspondre exactement.",
  "This split or merge would create a cycle in the retained lot genealogy.": "Cette division ou fusion créerait un cycle dans la généalogie conservée des lots.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "La quantité doit être positive, avec au plus six décimales et douze chiffres entiers.",
  "Offline storage is unavailable. No local save was confirmed.": "Le stockage hors ligne est indisponible. Aucun enregistrement local n’a été confirmé.",
  "Offline recording requires browser storage locking.": "L’enregistrement hors ligne nécessite le verrouillage du stockage du navigateur.",
  "Offline storage could not save the change. Keep the original work and retry.": "Le stockage hors ligne n’a pas pu enregistrer la modification. Conservez le travail initial et réessayez.",
  "Offline session not found.": "Session hors ligne introuvable.",
  "Resolve the saved change shown above before synchronizing offline work.": "Résolvez la modification enregistrée affichée ci-dessus avant de synchroniser le travail hors ligne.",
  "This offline session is not the active recorder.": "Cette session hors ligne n’est pas la session d’enregistrement active.",
  "Offline file storage is unavailable in this browser.": "Le stockage de fichiers hors ligne est indisponible dans ce navigateur.",
  "Offline storage capacity cannot be checked.": "La capacité du stockage hors ligne ne peut pas être vérifiée.",
  "Not enough browser storage for the selected offline files.": "Le stockage du navigateur est insuffisant pour les fichiers hors ligne sélectionnés.",
  "Streaming downloads are unavailable.": "Les téléchargements en continu sont indisponibles.",
  "Choose one job and distinct offline files.": "Choisissez un ordre et des fichiers hors ligne distincts.",
  "Choose distinct material lots and component units for offline use.": "Choisissez des lots de matériaux et des unités de composants distincts pour une utilisation hors ligne.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Reconnectez-vous, résolvez le travail hors ligne actif et fermez-le explicitement avant de changer de personne ou d’ordre.",
  "Finish preparation or closing before resolving offline work.": "Terminez la préparation ou la fermeture avant de résoudre le travail hors ligne.",
  "Choose an unresolved conflicting or rejected command.": "Choisissez une action en conflit ou rejetée non résolue.",
  "This offline session is not ready for new commands.": "Cette session hors ligne n’est pas prête pour de nouvelles actions.",
  "Choose distinct evidence staged in this offline session.": "Choisissez des justificatifs distincts stockés dans cette session hors ligne.",
  "Only operation attempts and inspections support staged evidence.": "Seules les tentatives d’opération et les contrôles prennent en charge les justificatifs stockés localement.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Téléversez et vérifiez les justificatifs hors ligne référencés avant de synchroniser cette action.",
  "Select at most 1000 evidence files.": "Sélectionnez au maximum 1000 fichiers justificatifs.",
  "Finish preparation or closing before synchronizing.": "Terminez la préparation ou la fermeture avant de synchroniser.",
  "Finish preparation before synchronizing.": "Terminez la préparation avant de synchroniser.",
  "The offline command response did not confirm acceptance.": "La réponse à l’action hors ligne n’a pas confirmé son acceptation.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Téléversez et joignez les justificatifs hors ligne stockés avant de fermer. Les justificatifs locaux sont conservés.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Résolvez tout le travail en attente, en conflit ou rejeté avant de fermer cette session hors ligne.",
  "The server session was closed elsewhere. Review the retained local work.": "La session serveur a été fermée ailleurs. Consultez le travail local conservé.",
  "The server did not confirm closing this offline session.": "Le serveur n’a pas confirmé la fermeture de cette session hors ligne.",
  "This file has not been downloaded and verified for offline use.": "Ce fichier n’a pas été téléchargé et vérifié pour une utilisation hors ligne.",
  "This offline session is not ready for new evidence.": "Cette session hors ligne n’est pas prête pour de nouveaux justificatifs.",
  "Choose a nonempty evidence file and filename.": "Choisissez un fichier justificatif non vide et indiquez son nom.",
  "This evidence has not been staged for offline use.": "Ce justificatif n’a pas été stocké pour une utilisation hors ligne.",
  "Finish closing before updating evidence.": "Terminez la fermeture avant de mettre à jour les justificatifs.",
  "Offline evidence changed. Read its current state before continuing.": "Les justificatifs hors ligne ont changé. Consultez leur état actuel avant de continuer.",
  "Resume the original evidence upload.": "Reprenez le téléversement initial du justificatif.",
  "The verified server file does not match the staged evidence.": "Le fichier serveur vérifié ne correspond pas au justificatif stocké localement.",
  "This offline session belongs to another recorder.": "Cette session hors ligne appartient à une autre personne.",
  "This offline session is closed. Its pending work cannot be submitted here.": "Cette session hors ligne est fermée. Son travail en attente ne peut pas être soumis ici.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "Cet identifiant d’action est déjà lié à un autre travail. Conservez l’action initiale et enregistrez toute correction séparément.",
  "Use a serial reserved for this job before the session was prepared.": "Utilisez un numéro de série réservé à cet ordre avant la préparation de la session.",
  "This component unit changed. Keep the recorded work and review the conflict.": "Cette unité de composant a changé. Conservez le travail enregistré et examinez le conflit.",
  "This component revision changed. Keep the recorded work and review the conflict.": "Cette révision de composant a changé. Conservez le travail enregistré et examinez le conflit.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "Ce lot de matériau a changé. Conservez le travail enregistré et examinez le conflit de stock avant de soumettre une correction.",
  "This material revision changed. Keep the recorded work and review the conflict.": "Cette révision du matériau a changé. Conservez le travail enregistré et examinez le conflit.",
  "The command payload does not match its record type. Keep the original pending work for review.": "Les données de l’action ne correspondent pas au type d’enregistrement. Conservez le travail initial en attente pour examen.",
  "Not started": "Non commencé",
  "In progress": "En cours",
  "Captured part revision was a draft.": "La révision de pièce capturée était un brouillon.",
  "Captured configuration was a draft.": "La configuration capturée était un brouillon.",
  "A captured component revision was a draft.": "Une révision de composant capturée était un brouillon.",
  "Captured material revision was a draft.": "La révision du matériau capturée était un brouillon.",
  "Captured route revision was a draft.": "La révision de gamme capturée était un brouillon.",
  "A captured document revision was a draft.": "Une révision de document capturée était un brouillon.",
  "No route was captured.": "Aucune gamme n’a été capturée.",
  "An operation has no completed attempt.": "Une opération ne comporte aucune tentative terminée.",
  "An expected inspection was not recorded.": "Un contrôle prévu n’a pas été enregistré.",
  "The history includes failed operations.": "L’historique comprend des opérations échouées.",
  "The history includes skipped operations.": "L’historique comprend des opérations ignorées.",
  "The history includes failed inspections.": "L’historique comprend des contrôles échoués.",
  "The history includes inconclusive inspections.": "L’historique comprend des contrôles non concluants.",
  "No inspection evidence was recorded.": "Aucun justificatif de contrôle n’a été enregistré.",
  "Planned components have no recorded actuals.": "Les composants prévus n’ont aucune utilisation réelle enregistrée.",
  "A planned component quantity differs from the recorded actuals.": "La quantité prévue d’un composant diffère de la quantité réelle enregistrée.",
  "Quality has not been declared.": "L’état de qualité n’a pas été déclaré.",
  "Production has not been declared.": "L’état de production n’a pas été déclaré.",
  "Some actual components are recorded for the whole job, not an individual output.": "Certains composants réels sont enregistrés pour l’ordre entier, et non pour une sortie individuelle.",
  "Some completed operations have no file evidence.": "Certaines opérations terminées n’ont aucun fichier justificatif.",
  "An operation was recorded out of order.": "Une opération a été enregistrée hors de l’ordre prévu.",
  "The serial label is void.": "L’identifiant de série est invalidé.",
  "Additional evidence warning recorded.": "Avertissement supplémentaire sur les justificatifs enregistré.",
  "Document": "Document",
  "Applies to output": "S’applique à la sortie",
  "Earlier lot": "Lot antérieur",
  "From lot": "Du lot",
  "Captured component evidence": "Justificatifs de composant capturés",
  "Actual genealogy": "Généalogie réelle",
  "Related operation": "Opération associée",
  "Shared runs": "Exécutions de production communes",
  "Add job to shared run": "Ajouter un ordre à l’exécution commune",
  "Actual component type": "Type de composant réel",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "Une action d’enregistrement acceptée doit confirmer cette pièce justificative jointe.",
  "Choose a downloaded material lot or component serial.": "Choisissez un lot de matériau ou un composant sérialisé téléchargé.",
  "Choose a supported evidence update.": "Choisissez une mise à jour de justificatif prise en charge.",
  "Choose a supported offline command and an object payload.": "Choisissez une action hors ligne prise en charge et des données sous forme d’objet.",
  "Choose the output receiving this component.": "Choisissez la sortie recevant ce composant.",
  "Evidence file references must be a list of server file IDs.": "Les références de fichiers justificatifs doivent être une liste d’identifiants de fichiers serveur.",
  "Evidence upload failed.": "Échec du téléversement du justificatif.",
  "Offline payloads must contain only JSON values.": "Les données des actions hors ligne ne doivent contenir que des valeurs JSON.",
  "Online registry": "Registre en ligne",
  "Provide a corrected command payload object.": "Fournissez les données corrigées de l’action sous forme d’objet.",
  "Provide the evidence upload error.": "Indiquez l’erreur de téléversement du justificatif.",
  "Reconnect to verify recorder access before synchronizing.": "Reconnectez-vous pour vérifier l’accès de la personne chargée de l’enregistrement avant de synchroniser.",
  "The offline bundle is missing selected material lots or component units.": "Il manque des lots de matériaux ou des unités de composants sélectionnés dans le lot de données hors ligne.",
  "The offline file SHA-256 does not match its manifest.": "Le SHA-256 du fichier hors ligne ne correspond pas à son manifeste.",
  "The offline file URL does not match its session.": "L’URL du fichier hors ligne ne correspond pas à sa session.",
  "The offline file length does not match its manifest.": "La taille du fichier hors ligne ne correspond pas à son manifeste.",
  "The offline file manifest is invalid.": "Le manifeste du fichier hors ligne est invalide.",
  "The offline manifest does not match the selected files.": "Le manifeste hors ligne ne correspond pas aux fichiers sélectionnés.",
  "The offline session does not belong to this recorder and job.": "La session hors ligne n’appartient pas à cette personne et à cet ordre.",
  "The prepared offline bundle does not match this recorder and job.": "Le lot de données hors ligne préparé ne correspond pas à cette personne et à cet ordre.",
  "The retained correction chain is incomplete.": "La chaîne de corrections conservée est incomplète.",
  "The retained correction chain is invalid.": "La chaîne de corrections conservée est invalide.",
  "The selected job changed. Open its download choices again.": "L’ordre sélectionné a changé. Rouvrez ses options de téléchargement.",
  "The selected offline file could not be downloaded.": "Le fichier hors ligne sélectionné n’a pas pu être téléchargé.",
  "The staged evidence failed SHA-256 verification.": "Le justificatif stocké localement a échoué à la vérification SHA-256.",
  "The stored offline evidence failed SHA-256 verification.": "Le justificatif hors ligne enregistré a échoué à la vérification SHA-256.",
  "The stored offline file failed SHA-256 verification.": "Le fichier hors ligne enregistré a échoué à la vérification SHA-256.",
  "This offline session is closed.": "Cette session hors ligne est fermée.",
  "This offline session is closed. Pending work is retained.": "Cette session hors ligne est fermée. Le travail en attente est conservé.",
  "Agent": "Agent",
  "Agents": "Agents",
  "Member": "Membre",
  "Agent name": "Nom de l’agent",
  "Agent reference": "Référence de l’agent",
  "Connected applications": "Applications connectées",
  "Connection address": "Adresse de connexion",
  "MCP endpoint": "Point de terminaison MCP",
  "New agent": "Nouvel agent",
  "Create agent": "Créer l’agent",
  "Manage": "Gérer",
  "Review transfer": "Examiner le transfert",
  "Management transfer awaiting your response": "Le transfert de gestion attend votre réponse",
  "Management transfer pending": "Transfert de gestion en attente",
  "No connected applications.": "Aucune application connectée.",
  "No agents yet.": "Aucun agent pour le moment.",
  "Last used {date}": "Dernière utilisation : {date}",
  "Disconnect": "Déconnecter",
  "Disconnect {name}?": "Déconnecter {name} ?",
  "This application will lose access through this connection.": "Cette application perdra l’accès via cette connexion.",
  "Manage {name}?": "Gérer {name} ?",
  "Accept management": "Accepter la gestion",
  "Decline transfer": "Refuser le transfert",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Accepter la gestion révoque les identifiants existants. Créez-en de nouveaux avant de relancer cet agent.",
  "Disabled": "Désactivé",
  "Enable agent": "Activer l’agent",
  "Disable agent": "Désactiver l’agent",
  "Enable {name}?": "Activer {name} ?",
  "Disable {name}?": "Désactiver {name} ?",
  "Rename": "Renommer",
  "Rename agent": "Renommer l’agent",
  "Transfer management": "Transférer la gestion",
  "Cancel transfer": "Annuler le transfert",
  "Request transfer": "Demander le transfert",
  "New manager’s Google account email": "Adresse Google du nouveau gestionnaire",
  "Share agent reference": "Partager la référence de l’agent",
  "Company access": "Accès aux entreprises",
  "No company access. A company owner can add this agent in Members.": "Aucun accès aux entreprises. Un propriétaire peut ajouter cet agent dans Membres.",
  "Credentials": "Identifiants",
  "New credential": "Nouvel identifiant",
  "Create credential": "Créer l’identifiant",
  "Credential name": "Nom de l’identifiant",
  "No credentials yet.": "Aucun identifiant pour le moment.",
  "Rotate secret": "Renouveler le secret",
  "Rotate {name}?": "Renouveler le secret de {name} ?",
  "Revoke {name}?": "Révoquer {name} ?",
  "Create new credentials after enabling this agent.": "Créez de nouveaux identifiants après avoir activé cet agent.",
  "This revokes its credentials and stops access in every company.": "Cela révoque ses identifiants et arrête l’accès à toutes les entreprises.",
  "Existing access tokens issued with this credential will stop working.": "Les jetons d’accès émis avec cet identifiant cesseront de fonctionner.",
  "Connection credentials": "Identifiants de connexion",
  "Client ID": "Identifiant client",
  "Client secret": "Secret client",
  "The secret is shown only once. Save it in your agent’s credential storage.": "Le secret n’est affiché qu’une fois. Enregistrez-le dans le stockage d’identifiants de votre agent.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "L’identifiant a été créé, mais son secret ne peut plus être affiché. Renouvelez le secret.",
  "Copy {value}": "Copier {value}",
  "Copy was unavailable. Select the value and copy it manually.": "La copie est indisponible. Sélectionnez la valeur et copiez-la manuellement.",
  "Add agent": "Ajouter un agent",
  "Choose a valid agent reference.": "Indiquez une référence d’agent valide.",
  "Managed by {name}": "Géré par {name}",
  "Connect application": "Connecter une application",
  "Allow connection": "Autoriser la connexion",
  "Redirect address": "Adresse de redirection",
  "This application can use your current company roles. Access follows changes to your memberships.": "Cette application peut utiliser vos rôles actuels dans les entreprises. L’accès suit les changements de vos adhésions.",
  "Agent created": "Agent créé",
  "Agent updated": "Agent mis à jour",
  "Agent disabled": "Agent désactivé",
  "Credential created": "Identifiant créé",
  "Credential rotated": "Identifiant renouvelé",
  "Credential revoked": "Identifiant révoqué",
  "Transfer requested": "Transfert demandé",
  "Transfer cancelled": "Transfert annulé",
  "Transfer accepted": "Transfert accepté",
  "Active agent not found.": "Agent actif introuvable.",
  "Agent not found.": "Agent introuvable.",
  "Managed agent not found.": "Agent géré introuvable.",
  "Credential not found.": "Identifiant introuvable.",
  "Connection not found.": "Connexion introuvable.",
  "Transfer not found.": "Transfert introuvable.",
  "This transfer has expired.": "Ce transfert a expiré.",
  "Choose another manager.": "Choisissez un autre gestionnaire.",
  "The new manager must sign in to the registry first.": "Le nouveau gestionnaire doit d’abord se connecter au registre.",
  "A human account manages agent credentials.": "Un compte humain gère les identifiants des agents.",
  "Enable the agent before creating credentials.": "Activez l’agent avant de créer des identifiants.",
  "Create a new credential after revocation.": "Créez un nouvel identifiant après la révocation.",
  "This agent is already a member.": "Cet agent est déjà membre.",
  "Another owner must accept membership before disabling the last owner.": "Un autre propriétaire doit accepter l’adhésion avant de désactiver le dernier.",
  "Application not found.": "Application introuvable.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Pièces communes",
  "Common": "Commune",
  "Add part to {value0}": "Ajouter une pièce à {value0}",
  "Assembly actions": "Actions de l’assemblage",
  "Create symmetry": "Créer une symétrie",
  "Variant created.": "Variante créée.",
  "Symmetry family updated.": "Famille de symétrie mise à jour.",
  "Document categories": "Catégories de documents",
  "Document category": "Catégorie de document",
  "Add category": "Ajouter une catégorie",
  "Edit category": "Modifier la catégorie",
  "Edit category {name}": "Modifier la catégorie {name}",
  "Category added.": "Catégorie ajoutée.",
  "Category saved.": "Catégorie enregistrée.",
  "Category name": "Nom de la catégorie",
  "Category code": "Code de la catégorie",
  "App default": "Par défaut",
  "Archived": "Archivée",
  "Show archived categories": "Afficher les catégories archivées",
  "No categories available.": "Aucune catégorie disponible.",
  "Reload": "Recharger",
  "Only company owners and editors can manage document categories.": "Seuls les propriétaires et éditeurs de l’entreprise peuvent gérer les catégories de documents.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Des catégories existantes partagent ces codes : {codes}. Leurs enregistrements restent distincts.",
  "Upload document": "Téléverser un document",
  "Apply to selected": "Appliquer à la sélection",
  "Back to files": "Retour aux fichiers",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "Le stockage du navigateur est indisponible. Gardez cette fenêtre ouverte pour conserver vos modifications.",
  "Category for {name}": "Catégorie de {name}",
  "Check the saved upload change before continuing.": "Vérifiez la modification enregistrée du téléversement avant de continuer.",
  "Choose a matching document": "Choisir un document correspondant",
  "Choose which document should receive this revision.": "Choisissez le document auquel ajouter cette révision.",
  "Create a separate document": "Créer un document distinct",
  "Detected from": "Détecté à partir de",
  "Drag and drop files here": "Glissez-déposez les fichiers ici",
  "Edit selected files": "Modifier les fichiers sélectionnés",
  "Edit {count} selected files": "Modifier les {count} fichiers sélectionnés",
  "File details and applicability": "Détails et applicabilité du fichier",
  "File preview": "Aperçu du fichier",
  "File size": "Taille du fichier",
  "Filename": "Nom du fichier",
  "Keep current": "Conserver les valeurs actuelles",
  "Matching document for {name}": "Document correspondant à {name}",
  "New document": "Nouveau document",
  "New revision of {identifier}": "Nouvelle révision de {identifier}",
  "Next file": "Fichier suivant",
  "Not specified": "Non précisé",
  "Preview unavailable for this file format.": "Aucun aperçu disponible pour ce format de fichier.",
  "Preview {name}": "Aperçu de {name}",
  "Previous file": "Fichier précédent",
  "Reading file details…": "Lecture des détails des fichiers…",
  "Recover saved upload": "Récupérer le téléversement enregistré",
  "Select a file to preview.": "Sélectionnez un fichier à prévisualiser.",
  "Select all files": "Sélectionner tous les fichiers",
  "Select files": "Sélectionner des fichiers",
  "Select files to upload.": "Sélectionnez les fichiers à téléverser.",
  "Select the original file to preview or resume.": "Sélectionnez le fichier d’origine pour le prévisualiser ou reprendre le téléversement.",
  "Select the original file to resume.": "Sélectionnez le fichier d’origine pour reprendre le téléversement.",
  "Select {name}": "Sélectionner {name}",
  "Title for {name}": "Titre de {name}",
  "Title pattern": "Modèle de titre",
  "Uploading {name}": "Téléversement de {name}",
  "Use {name} for the current title and {n} for a sequence number.": "Utilisez {name} pour le titre actuel et {n} pour un numéro d’ordre.",
  "{count} files": "{count} fichiers",
  "{count} selected": "{count} sélectionnés",
  "{done} of {total} uploaded": "{done} sur {total} téléversés",
  "Add files": "Ajouter des fichiers",
  "Retry unfinished uploads": "Réessayer les téléversements inachevés",
  "Drawing": "Plan",
  "Assembly drawing": "Plan d’ensemble",
  "Production drawing": "Plan de fabrication",
  "Bill of materials": "Nomenclature",
  "Work instruction": "Instruction de travail",
  "Schematic": "Schéma de principe",
  "Wiring diagram": "Schéma de câblage",
  "Layout": "Implantation",
  "3D model": "Modèle 3D",
  "Test procedure": "Procédure d’essai",
  "Test report": "Rapport d’essai",
  "Inspection plan": "Plan de contrôle",
  "Inspection report": "Rapport de contrôle",
  "Certificate": "Certificat",
  "Material datasheet": "Fiche technique du matériau",
  "Calculation": "Calcul",
  "Requirements": "Exigences",
  "Design report": "Rapport de conception",
  "Assembly instruction": "Instruction d’assemblage",
  "Manufacturing process": "Procédé de fabrication",
  "Quality plan": "Plan qualité",
  "Change notice": "Avis de modification",
  "Manual": "Manuel",
  "Upload": "Téléverser",
  "Ready": "Prêt",
  "Needs attention": "À vérifier",
  "Retained": "Conservée",
  "manual": "Modification manuelle",
  "filename": "Nom du fichier",
  "embedded metadata": "Métadonnées intégrées",
  "filename fallback": "Nom du fichier ; catégorie générale",
  "Embedded metadata": "Métadonnées intégrées",
  "Embedded title": "Titre intégré",
  "File selection key": "Clé de sélection du fichier",
  "Media type": "Type de média",
  "Document category added": "Catégorie de documents ajoutée",
  "Document category archived": "Catégorie de documents archivée",
  "Document category updated": "Catégorie de documents mise à jour",
  "Document upload batch created": "Lot de téléversement de documents créé",
  "Document draft retained": "Brouillon du document conservé",
  "Document upload saved": "Document téléversé enregistré",
  "Add a Company or Project category.": "Ajoutez une catégorie d’entreprise ou de projet.",
  "Choose a category available in this document context.": "Choisissez une catégorie disponible dans le contexte de ce document.",
  "Choose a project only for a Project category.": "Choisissez un projet uniquement pour une catégorie de projet.",
  "Choose the project that owns this document context.": "Choisissez le projet auquel appartient le contexte de ce document.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "Ce code de catégorie existe déjà dans ce périmètre ou dans un périmètre hérité. Choisissez un autre code.",
  "This category is archived. Choose an available category.": "Cette catégorie est archivée. Choisissez une catégorie disponible.",
  "This editable category was not found in this company.": "Cette catégorie modifiable est introuvable dans cette entreprise.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Utilisez un code de catégorie composé de lettres majuscules et de chiffres, commençant par une lettre.",
  "A saved document file cannot be removed from its upload batch.": "Un fichier de document enregistré ne peut pas être retiré de son lot de téléversement.",
  "A selected file key is already in this batch.": "La clé d’un fichier sélectionné figure déjà dans ce lot.",
  "Choose a document category.": "Choisissez une catégorie de document.",
  "Choose a row in this upload batch.": "Choisissez une ligne de ce lot de téléversement.",
  "Choose an available document category.": "Choisissez une catégorie de document disponible.",
  "Choose between 1 and 1000 files.": "Choisissez entre 1 et 1000 fichiers.",
  "Choose distinct upload rows to edit.": "Choisissez des lignes de téléversement distinctes à modifier.",
  "Choose either an existing document or a new document.": "Choisissez un document existant ou un nouveau document.",
  "Resume this batch with the recorder who started it.": "Reprenez ce lot avec le compte qui l’a démarré.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Plusieurs documents correspondent à ce fichier. Choisissez le document voulu ou créez un document distinct.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "Le document sélectionné ne correspond plus à ce propriétaire, cette catégorie et ce titre. Vérifiez à nouveau la ligne.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "Ce document a un téléversement inachevé. Terminez-le ou annulez-le avant de réessayer cette ligne.",
  "This upload batch was cancelled.": "Ce lot de téléversement a été annulé.",
  "This upload row is already saved or cancelled.": "Cette ligne de téléversement est déjà enregistrée ou annulée.",
  "Upload and verify this file before saving the document.": "Téléversez et vérifiez ce fichier avant d’enregistrer le document.",
  "Select the original file for this upload row.": "Sélectionnez le fichier d’origine pour cette ligne de téléversement.",
  "This row already has a different upload. Cancel that upload before replacing it.": "Cette ligne contient déjà un autre téléversement. Annulez-le avant de le remplacer.",
  "Preview will be available after upload.": "L’aperçu sera disponible après le téléversement.",
  "existing document": "Document existant",
  "file extension": "Extension du fichier",
  "More": "Plus",
  "Edit quantity for {value0}": "Modifier la quantité pour {value0}",
  "This structure cannot contain itself.": "Cette structure ne peut pas se contenir elle-même."
}
